<template>
  <!-- 费用录入 -->
  <div class="contentBox">
    <el-collapse v-model="activeNames">
      <!-- 基本信息 -->
      <el-collapse-item title="基本信息" name="1">
        <div class="infoDiv">
          <div class="formbox">
            <el-form
              :model="baseInForm"
              :rules="rulesBaseInform"
              ref="baseInFormRef"
              label-width="100px"
              class="glo_formBox"
              disabled
            >
              <div class="teSu">
                <el-form-item label="关联提货单:" prop>
                  <div class="displayFlex">
                    <el-input
                      v-model="baseInForm.commandNumber"
                      placeholder="请选择"
                      disabled
                    ></el-input>
                    <i
                      v-if="baseInForm.commandNumber"
                      @click="clearComman()"
                      class="clearIcon el-icon-circle-close"
                    ></i>
                    <el-button
                      class="glo_bgcMainColor formBtns"
                      @click="changeTiHuoDanDia"
                      >选择</el-button
                    >
                  </div>
                </el-form-item>
                <el-form-item label="客户名称:" prop="customerName">
                  <div class="displayFlex">
                    <el-input
                      v-model="baseInForm.customerName"
                      placeholder="请选择"
                      readonly
                    ></el-input>
                    <el-button
                      @click="changeCustomerDia"
                      class="glo_bgcMainColor formBtns"
                      >选择</el-button
                    >
                  </div>
                </el-form-item>
              </div>

              <el-form-item label="运单号:" prop="waybillNumber">
                <el-input
                  v-model="baseInForm.waybillNumber"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="客户单号:" prop="customerOrderNumber">
                <el-input
                  v-model="baseInForm.customerOrderNumber"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="货物类型:" prop="waybillType	">
                <el-select
                  filterable
                  clearable
                  v-model="baseInForm.waybillType"
                  placeholder="请选择"
                  @focus="getConfDictValDownList('waybill_type')"
                >
                  <el-option
                    v-for="(item, index) in waybillTypeList"
                    :key="index"
                    :label="item.key"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="交货日期:" prop="deliveryTime">
                <el-date-picker
                  v-model="baseInForm.deliveryTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label="提货日期:" prop="takeTime">
                <el-date-picker
                  v-model="baseInForm.takeTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="提货状态:" prop="takeStatus">
                <el-switch
                  v-model="baseInForm.takeStatus"
                  active-text="已提货"
                  inactive-text="未提货"
                >
                </el-switch>
              </el-form-item>-->
              <el-form-item label="提货状态:" prop="takeStatus">
                <el-select v-model="baseInForm.takeStatus" placeholder="请选择">
                  <el-option
                    v-for="item in takeStatusList"
                    :key="item.val"
                    :label="item.name"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="提货人员:" prop="takeUserId">
                <el-select
                  filterable
                  clearable
                  v-model="baseInForm.takeUserId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in EmployeeList"
                    :key="item.documentId"
                    :label="item.name"
                    :value="item.documentId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <!-- 发货地址 -->
              <div class="addressBox">
                <div
                  v-for="(item, idx) in goodsInfoList"
                  :key="idx"
                  class="formbox goodsItmes"
                >
                  <el-form
                    :model="item.addressReq"
                    :rules="rulesGoods"
                    label-width="100px"
                    class="glo_formBox"
                    disabled
                  >
                    <el-form-item label="发货人:" prop="contacts">
                      <el-input
                        v-model="item.addressReq.contacts"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="发货单位:" prop="company">
                      <el-input
                        v-model="item.addressReq.company"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:" prop="phone">
                      <el-input
                        v-model="item.addressReq.phone"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <el-button
                      class="glo_bgcMainColor formBtns"
                      @click="changeRecAddress(2, idx)"
                      >选择发件地址</el-button
                    >
                    <div class="checkBox">
                      <el-checkbox v-model="item.isAutoAddr_jj"
                        >自动收录寄件地址</el-checkbox
                      >
                    </div>
                    <el-form-item
                      style="width: 100%; border: 0"
                      label="发货地址:"
                      prop="provinceName"
                    >
                      <div class="disFlexs">
                        <el-select
                          class="selectAddress"
                          v-model="item.addressReq.provinceName"
                          placeholder="请选择省"
                          clearable
                          filterable
                          @change="changeProvinceFH($event, idx)"
                        >
                          <el-option
                            v-for="(itemp, indexp) in SuperiorRegionList"
                            :key="indexp"
                            :label="itemp.districtName"
                            :value="itemp.districtName"
                          ></el-option>
                        </el-select>
                        <el-select
                          class="selectAddress"
                          v-model="item.addressReq.cityName"
                          placeholder="请选择市"
                          clearable
                          filterable
                          @change="changeCityFH($event, idx)"
                          @focus="
                            getCityNameFH(item.addressReq.provinceName, idx)
                          "
                        >
                          <el-option
                            v-for="(itemc, indexc) in item.cityNameList"
                            :key="indexc"
                            :label="itemc.districtName"
                            :value="itemc.districtName"
                          ></el-option>
                        </el-select>
                        <el-select
                          class="selectAddress"
                          v-model="item.addressReq.areaName"
                          placeholder="请选择区"
                          clearable
                          filterable
                          @focus="getAreaNameFH(item.addressReq.cityName, idx)"
                        >
                          <el-option
                            v-for="(itema, indexa) in item.areaNameList"
                            :key="indexa"
                            :label="itema.districtName"
                            :value="itema.districtName"
                          ></el-option>
                        </el-select>
                        <el-input
                          class="selectAddress addressDetails"
                          v-model="item.addressReq.address"
                          placeholder="请输入详细地址"
                          clearable
                          @keyup.enter.native="
                            geocodeFH(item.addressReq.address, idx)
                          "
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-form>
                </div>
              </div>

              <!-- 收货地址 -->
              <div class="addressBox">
                <el-form
                  :model="shouJiForm"
                  :rules="rulesAddress"
                  ref="shouJiFormRef"
                  label-width="100px"
                  class="glo_formBox"
                  disabled
                >
                  <el-form-item label="收货人:" prop="contacts">
                    <el-input
                      v-model="shouJiForm.contacts"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收货单位:">
                    <el-input
                      v-model="shouJiForm.company"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话:" prop="phone">
                    <el-input
                      v-model="shouJiForm.phone"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-button
                    class="glo_bgcMainColor formBtns"
                    @click="changeRecAddress(1)"
                    >选择收件地址</el-button
                  >
                  <div class="checkBox">
                    <el-checkbox v-model="isAutoAddr_sj"
                      >自动收录收货地址</el-checkbox
                    >
                  </div>
                  <el-form-item
                    style="width: 100%; border: 0"
                    prop="provinceName"
                    label="收货地址:"
                  >
                    <div class="disFlexs">
                      <el-select
                        class="selectAddress"
                        v-model="shouJiForm.provinceName"
                        placeholder="请选择省"
                        clearable
                        filterable
                        @change="changeProvince"
                      >
                        <el-option
                          v-for="(item, index) in SuperiorRegionList"
                          :key="index"
                          :label="item.districtName"
                          :value="item.districtName"
                        ></el-option>
                      </el-select>
                      <el-select
                        class="selectAddress"
                        v-model="shouJiForm.cityName"
                        placeholder="请选择市"
                        clearable
                        filterable
                        @change="changeCity"
                        @focus="getCityName(shouJiForm.provinceName)"
                      >
                        <el-option
                          v-for="(item, index) in cityNameList"
                          :key="index"
                          :label="item.districtName"
                          :value="item.districtName"
                        ></el-option>
                      </el-select>
                      <el-select
                        class="selectAddress"
                        v-model="shouJiForm.areaName"
                        placeholder="请选择区"
                        clearable
                        filterable
                        @focus="getAreaName(shouJiForm.cityName)"
                      >
                        <el-option
                          v-for="(item, index) in areaNameList"
                          :key="index"
                          :label="item.districtName"
                          :value="item.districtName"
                        ></el-option>
                      </el-select>
                      <el-input
                        class="selectAddress addressDetails"
                        v-model="shouJiForm.address"
                        placeholder="请输入详细地址"
                        clearable
                        @keyup.enter.native="geocode(shouJiForm.address)"
                      ></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item
                    class="textArea"
                    style="width: 100%"
                    label="送货要求:"
                    prop="remarks"
                  >
                    <el-input
                      type="textarea"
                      rows="2"
                      v-model="shouJiForm.remarks"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>

              <el-form-item
                class="textArea"
                style="width: 100%"
                label="开单备注:"
                prop="remarks"
              >
                <el-input
                  type="textarea"
                  rows="2"
                  v-model="baseInForm.remarks"
                ></el-input>
              </el-form-item>

              <el-form-item label="到货区域:" prop="arrivalArea">
                <el-input
                  v-model="baseInForm.arrivalArea"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="交货方式:" prop="sendMethodConfDictId">
                <el-select
                  filterable
                  clearable
                  v-model="baseInForm.sendMethodConfDictId"
                  placeholder="请选择"
                  @change="changesendMethod"
                >
                  <el-option
                    v-for="(item, index) in sendMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运输方式:" prop="transportMethodConfDictId">
                <el-select
                  filterable
                  clearable
                  v-model="baseInForm.transportMethodConfDictId"
                  placeholder="请选择"
                  @change="changetransportMethod"
                >
                  <el-option
                    v-for="(item, index) in transportModeList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="回单要求:" prop="rnRequireConfDictId">
                <div class="glo_disFlex" style="padding-right: 3px">
                  <el-select
                    style="flex"
                    v-model="baseInForm.rnRequireConfDictId"
                    placeholder="请选择"
                    filterable
                    clearable
                    @change="changernRequireName"
                  >
                    <el-option
                      v-for="item in rnrderRequireList"
                      :key="item.confDictId"
                      :label="item.key"
                      :value="item.confDictId"
                    ></el-option>
                  </el-select>
                  <el-input
                    class="miniInput"
                    v-model="baseInForm.rnRequireCount"
                    placeholder="份数"
                    type="number"
                  ></el-input
                  >份
                </div>
              </el-form-item>

              <el-form-item label="收货方式:" prop="receiveMethodConfDictId">
                <el-select
                  filterable
                  clearable
                  v-model="baseInForm.receiveMethodConfDictId"
                  placeholder="请选择"
                  @change="changereceiveMethod"
                >
                  <el-option
                    v-for="(item, index) in ReceivingMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否需要分拣:" prop="isSorting">
                <el-switch
                  v-model="baseInForm.isSorting"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </el-form-item>
              <el-form-item label="是否投保:" prop="isInsure">
                <el-switch
                  v-model="baseInForm.isInsure"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </el-form-item>

              <el-form-item
                label="声明价值:"
                prop="declaredValue"
                v-if="baseInForm.isInsure"
              >
                <div class="glo_disFlex" style="padding-right: 3px">
                  <el-input
                    class
                    type="number"
                    v-model="baseInForm.declaredValue"
                    placeholder="请输入数字"
                  ></el-input>
                  <el-input
                    class="miniInput"
                    type="number"
                    placeholder="费率"
                    v-model="baseInForm.declaredValueRate"
                  ></el-input
                  >‰
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 运单图片 -->
          <div style="margin-left: 30px">
            <div style="margin-bottom: 10px">
              上传图片: (支持上传jpg/png文件)
            </div>
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="9"
            ></uploadimgs>
          </div>
        </div>
      </el-collapse-item>

      <!-- 货物信息 -->
      <el-collapse-item title="货物信息" name="2">
        <div class="infoDiv" id="tables">
          <div
            v-for="(item, idx) in goodsInfoList"
            :key="idx"
            class="formbox goodsItmes"
          >
            <div
              class="glo_Table goodsTable"
              v-for="(itemA, idx2) in item.itemReqs"
              :key="idx2"
            >
              <!-- 货物表格 -->
              <el-table :data="item.itemReqs" border style="width: 100%">
                <el-table-column
                  fixed="left"
                  align="center"
                  label="序号"
                  type="index"
                  width="60"
                ></el-table-column>

                <el-table-column
                  show-overflow-tooltip
                  prop="goodsName"
                  label="*货物名称"
                >
                  <template slot-scope="scope">
                    <el-input
                      type="text"
                      v-model="item.itemReqs[scope.$index].goodsName"
                      placeholder="请输入"
                      filterable
                    ></el-input>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  show-overflow-tooltip
                  prop="itemCategoryName"
                  label="品类"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="item.itemReqs[scope.$index].itemCategoryName"
                      filterable
                      clearable
                      allow-create
                      default-first-option
                      placeholder="请选择"
                      @change="changeGoodsName($event, idx)"
                    >
                      <el-option
                        v-for="(item2, index2c) in item.itemReqs[scope.$index]
                          .CategoryList"
                        :key="index2c"
                        :label="item2.itemCategoryName"
                        :value="item2.itemCategoryName"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>-->
                <el-table-column prop="packageName" label="包装">
                  <template slot-scope="scope">
                    <el-select
                      v-model="item.itemReqs[scope.$index].packageName"
                      filterable
                      default-first-option
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item2, index2c) in item.itemReqs[scope.$index]
                          .packageNameList"
                        :key="index2c"
                        :label="item2.key"
                        :value="item2.key"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="packageCout" label="*件数">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="item.itemReqs[scope.$index].packageCout"
                      placeholder="请输入"
                      @input="billWeightCalculationById()"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="grossWeight" label="*毛重">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="item.itemReqs[scope.$index].grossWeight"
                      placeholder="请输入"
                      @input="billWeightCalculationById()"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="netWeight" label="净重">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="item.itemReqs[scope.$index].netWeight"
                      placeholder="请输入"
                      @input="billWeightCalculationById()"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="volumeDivisor" label="体积系数">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      @mousewheel.native.prevent
                      v-model="item.itemReqs[scope.$index].volumeDivisor"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="volumeWeight" label="体积重量">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="item.itemReqs[scope.$index].volumeWeight"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="volume" label="*体积/m³">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="item.itemReqs[scope.$index].volume"
                      placeholder="请输入"
                      @input="billWeightCalculationById()"
                    ></el-input>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  prop="billingWeight"
                  label="*计费取值"
                  width="120"
                >
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="item.itemReqs[scope.$index].billingWeight"
                      placeholder="请输入"
                      @input="getGoodsTable(idx, scope.$index)"
                    ></el-input>
                  </template>
                </el-table-column>-->
                <!-- <el-table-column prop="unitPrice" label="*单价">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="item.itemReqs[scope.$index].unitPrice"
                      placeholder="请输入"
                      @input="getGoodsTable(idx, scope.$index)"
                    ></el-input>
                  </template>
                </el-table-column>-->
                <!-- <el-table-column prop="freight" label="运费">
                  <template slot-scope="scope">
                    <el-input
                      type="text"
                      v-model="item.itemReqs[scope.$index].freight"
                      placeholder="请输入"
                      @input="getBasicFreight"
                    ></el-input>
                  </template>
                </el-table-column>-->
                <el-table-column prop="specs" label="规格">
                  <template>
                    <!-- <el-input
                      type="text"
                      readonly
                      disabled
                      v-model="item.itemReqs[scope.$index].specs"
                      placeholder="在下面加规格"
                    ></el-input>-->
                    <div @click="isShowDialog6 = true" class="linkTabel">
                      规格设置
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px">
                <el-button
                  class="glo_bgcMainColor saveBtnsAddGG"
                  @click="freightCalculation()"
                  >计算运费并获取报价方式</el-button
                >
              </div>
              <!-- 规格表格 -->
              <!-- <div class="huoWuBox">
                <el-table
                  :data="item.itemReqs[idx2].itemSpecsReqs"
                  border
                  class="speckTable"
                  style="width: 60%"
                >
                  <el-table-column
                    fixed="left"
                    align="center"
                    label="序号"
                    type="index"
                    width="60"
                  >
                  </el-table-column>

                  <el-table-column
                    show-overflow-tooltip
                    prop="length"
                    label="*长(cm)"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="text"
                        disabled
                        v-model="
                          item.itemReqs[idx2].itemSpecsReqs[scope.$index].length
                        "
                        placeholder="请输入"
                        filterable
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="wide"
                    label="*宽(cm)"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="text"
                        disabled
                        v-model="
                          item.itemReqs[idx2].itemSpecsReqs[scope.$index].wide
                        "
                        placeholder="请输入"
                        filterable
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="height"
                    label="*高(cm)"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="text"
                        disabled
                        v-model="
                          item.itemReqs[idx2].itemSpecsReqs[scope.$index].height
                        "
                        placeholder="请输入"
                        filterable
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="packageCout"
                    label="*件数"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="text"
                        disabled
                        v-model="
                          item.itemReqs[idx2].itemSpecsReqs[scope.$index]
                            .packageCout
                        "
                        placeholder="请输入"
                        filterable
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <div class="iconList">
                        <el-popconfirm
                          title="确定删除该行信息吗"
                          @confirm="delGoods(idx, idx2, scope.$index)"
                        >
                          <i
                            slot="reference"
                            class="el-icon-remove iconSize"
                          ></i>
                        </el-popconfirm>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>-->
            </div>
          </div>
        </div>
      </el-collapse-item>

      <!-- 财务应收 -->
      <el-collapse-item title="财务应收" name="3">
        <div class="infoDiv">
          <!-- <div class="h3title">财务应收</div> -->
          <div class="formbox">
            <el-form
              :model="CaiWuData"
              :rules="rulesYS"
              ref="CaiWuDataRef"
              label-width="100px"
              class="glo_formBox"
            >
              <el-form-item label="到货区域:" prop="arrivalArea">
                <el-input
                  v-model="baseInForm.arrivalArea"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="报价方式:" prop>
                <el-select
                  filterable
                  clearable
                  v-model="baseInForm.channelId"
                  placeholder="请选择"
                  @change="changeChannel"
                >
                  <el-option
                    v-for="item in channelIdList"
                    :key="item.channelId + ''"
                    :label="
                      item.channelName +
                        ' (' +
                        (item.formulaBillingWeightName || '无计费方式') +
                        ')'
                    "
                    :value="item.channelId + ''"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="报价到货区域:" prop>
                <el-select
                  filterable
                  clearable
                  v-model="baseInForm.channelArrivalAreaCode"
                  placeholder="请选择"
                  @change="changeChannelArrivalArea"
                >
                  <el-option
                    v-for="item in channelArrivalAreaList"
                    :key="item.channelOfferId + ''"
                    :label="item.offerName"
                    :value="item.channelOfferId + ''"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="计费方式:">
                <el-select
                  v-model="CaiWuData.formulaBillingWeightId"
                  placeholder="请选择"
                  clearable
                  @change="changeBILLMethode"
                >
                  <el-option
                    v-for="item in out_going_billing_method_list"
                    :key="item.formulaBillingWeightId + ''"
                    :label="item.formulaBillingWeightName"
                    :value="item.formulaBillingWeightId + ''"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="保险费:" prop="insuranceFee">
                <div class="disFlexs jsInput">
                  <el-input
                    v-model="CaiWuData.insuranceFee"
                    placeholder="请输入"
                    clearable
                    type="number"
                  ></el-input>
                  <el-button
                    v-if="baseInForm.isInsure"
                    class="jsBtns glo_bgcMainColor"
                    @click="getBXFee()"
                    >计算</el-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="计费取值:">
                <el-input
                  type="number"
                  @mousewheel.native.prevent
                  v-model="goodsInfoList[0].itemReqs[0].billingWeight"
                  placeholder="请输入"
                  @input="getGoodsTable(0, 0)"
                ></el-input>
              </el-form-item>
              <el-form-item label="单价:">
                <el-input
                  type="number"
                  @mousewheel.native.prevent
                  v-model="goodsInfoList[0].itemReqs[0].unitPrice"
                  placeholder="请输入"
                  @input="getGoodsTable(0, 0)"
                ></el-input>
              </el-form-item>
              <el-form-item label="基本运费:" prop="basicFreight">
                <div class="disFlexs jsInput">
                  <el-input
                    v-model="CaiWuData.basicFreight"
                    placeholder="请输入"
                    clearable
                    type="number"
                    @input="getTotalFreight()"
                  ></el-input>
                  <el-button
                    class="jsBtns glo_bgcMainColor"
                    @click="getBasicFreight()"
                    >计算</el-button
                  >
                </div>
              </el-form-item>

              <el-form-item label="提货费:" prop="takeFee">
                <el-input
                  v-model="CaiWuData.takeFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @input="getTotalFreight()"
                ></el-input>
              </el-form-item>
              <el-form-item label="送货费:" prop="sendFee">
                <el-input
                  v-model="CaiWuData.sendFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @input="getTotalFreight()"
                ></el-input>
              </el-form-item>
              <el-form-item label="包装费:" prop="packageFee">
                <el-input
                  v-model="CaiWuData.packageFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @input="getTotalFreight()"
                ></el-input>
              </el-form-item>
              <el-form-item label="装卸费:" prop="unLoadFee">
                <el-input
                  v-model="CaiWuData.unLoadFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @input="getTotalFreight()"
                ></el-input>
              </el-form-item>
              <el-form-item label="上楼费:" prop="upstairsFee">
                <el-input
                  v-model="CaiWuData.upstairsFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @input="getTotalFreight()"
                ></el-input>
              </el-form-item>
              <el-form-item label="等候费:" prop="waitingFee">
                <el-input
                  v-model="CaiWuData.waitingFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @input="getTotalFreight()"
                ></el-input>
              </el-form-item>
              <el-form-item label="二次送货费:" prop="againSendFee">
                <el-input
                  v-model="CaiWuData.againSendFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @input="getTotalFreight()"
                ></el-input>
              </el-form-item>

              <el-form-item label="其他费用:" prop="allOtherFee">
                <div class="disFlexs jsInput">
                  <el-input
                    v-model="CaiWuData.allOtherFee"
                    placeholder="请输入"
                    clearable
                    type="number"
                    @input="getTotalFreight()"
                  ></el-input>
                  <el-button
                    class="jsBtns glo_bgcMainColor"
                    @click="getOtherExpenses()"
                    >计算</el-button
                  >
                  <!-- <el-button
                    style="
                      background-color: #169bd5;
                      margin-left: 4px;
                      color: #fff;
                    "
                    class="jsBtns"
                    @click="getOtherExpenses()"
                    >明细</el-button
                  >-->
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="glo_Table" style="margin-bottom: 20px">
            <el-button
              class="glo_bgcMainColor"
              style="margin-bottom: 10px; margin-left: 30px"
              @click="AddFeiXian"
              >添加其他费项</el-button
            >
            <el-table
              ref="ysTable"
              :data="CaiWuData.itemServiceReqs"
              show-summary
              border
              class="feeAtherTb"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="itemServiceName"
                label="费项"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="itemCategoryName"
                label="费项类型"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="amount"
                label="金额"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="remarks"
                label="备注"
              ></el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <div class="iconList">
                    <!-- <el-button class="tbBtns" @click="AddFeiXian">添加</el-button> -->
                    <el-button
                      class="tbBtns"
                      @click="editFeiXian(scope.row, scope.$index)"
                      >编辑</el-button
                    >

                    <el-popconfirm
                      title="确定删除该行数据吗"
                      @confirm="delFeiXian(scope.$index)"
                    >
                      <el-button slot="reference" class="tbBtns"
                        >删除</el-button
                      >
                      <!-- <i slot="reference" class="el-icon-remove iconSize"></i> -->
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="formbox">
            <el-form
              :model="CaiWuData"
              :rules="rulesCaiWu"
              ref="CaiWuData"
              label-width="100px"
              class="glo_formBox"
            >
              <el-form-item
                label="总金额:"
                prop="totalFreight"
                class="redColor"
              >
                <div class="disFlexs jsInput">
                  <el-input
                    v-model="CaiWuData.totalFreight"
                    placeholder="请输入"
                    clearable
                    type="number"
                  ></el-input>
                  <el-button
                    class="jsBtns glo_bgcMainColor"
                    @click="getTotalFreight()"
                    >计算</el-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="结算方式:" prop="settlementMethodConfDictId">
                <el-select
                  filterable
                  clearable
                  v-model="CaiWuData.settlementMethodConfDictId"
                  placeholder="请选择"
                  @change="changeSettlementMethod"
                >
                  <el-option
                    v-for="item in settlementMethodList"
                    :key="item.confDictId"
                    :label="item.val"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                class="textArea"
                style="width: 100%; margin-right: 0"
                label="费用备注:"
                prop="remarks"
              >
                <el-input
                  type="textarea"
                  rows="2"
                  v-model="CaiWuData.remarks"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-collapse-item>
      <!-- 最后按钮 -->
      <div class="btmBtns">
        <el-button class="glo_bgcMainColor saveBtns" @click="submit(0)"
          >保存应收</el-button
        >
        <el-button
          v-if="isShowGuoZhang"
          style="margin-left: 40px"
          class="glo_bgcMainColor saveBtns"
          @click="submit(1)"
          >过账应收</el-button
        >
      </div>
      <!-- 财务应付 -->
      <el-collapse-item title="财务应付" name="4">
        <!-- 财务应付 -->
        <div class="infoDiv">
          <!-- <div class="h3title">财务应付</div> -->
          <div class="glo_Table" style="margin-bottom: 20px">
            <el-button
              class="glo_bgcMainColor"
              style="margin-bottom: 10px"
              @click="addYinFu"
              >添加应付</el-button
            >
            <el-table
              show-summary
              :data="financeOutInfoReqs"
              border
              style="width: 100%"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="itemCategoryName"
                label="费项类型"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="itemServiceName"
                label="费项名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="amount"
                label="金额"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="objectStatus"
                label="结算对象类型"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="objectName"
                label="结算对象"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="applyEmployeeName"
                label="垫付人"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="isExpenseShow"
                label="是否已申请报销"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="expenseNumber"
                label="报销单号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="paymentMethod"
                label="付款方式"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="remarks"
                label="备注"
              ></el-table-column>
              <el-table-column fixed="right" prop="cccc" label="操作">
                <template slot-scope="scope">
                  <div class="iconList">
                    <el-button
                      class="tbBtns"
                      :disabled="scope.row.isExpense == 1"
                      @click="EditFeiXian(scope.row, scope.$index)"
                      >编辑</el-button
                    >
                    <el-popconfirm
                      title="确定删除该行数据吗"
                      @confirm="delFeiXian2(scope.$index)"
                    >
                      <el-button
                        :disabled="scope.row.isExpense == 1"
                        slot="reference"
                        class="tbBtns"
                        >删除</el-button
                      >
                      <!-- <i slot="reference" class="el-icon-remove iconSize"></i> -->
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-collapse-item>

      <!-- 外发费用 -->
      <el-collapse-item title="外发费用" name="5">
        <div class="infoDiv">
          <div class="glo_Table" style="margin-bottom: 20px">
            <el-table
              show-summary
              :data="WaybillOutgoingFinance"
              border
              style="width: 100%"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="number"
                label="外发编号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="outgoingNumber"
                label="外发承运单号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="carrierName"
                label="承运商"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="outgoingRemarks"
                label="外发备注"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="sendMethod"
                label="送货方式"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="sendEmployeeName"
                label="发货人"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="applyReimburseStatus"
                label="是否申请报销"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="expenseNumber"
                label="报销单号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="totalAmount"
                label="实际费用合计"
              ></el-table-column>
              <!-- <el-table-column
                    align="center"
                    prop="amount"
                    label="实际费用"
              ></el-table-column>-->
              <el-table-column
                align="center"
                prop="basicFreight"
                label="实际运费"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="sendFee"
                label="实际送货费"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="allOtherFee"
                label="实际其他费用"
              ></el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <div class="iconList">
                    <el-button class="tbBtns" @click="edit7(scope.row)"
                      >编辑</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-collapse-item>

      <!-- 发车费用 -->
      <el-collapse-item title="发车费用" name="6">
        <div class="infoDiv">
          <div class="glo_Table" style="margin-bottom: 20px">
            <el-table
              show-summary
              :data="WaybillDispatchFinance"
              border
              style="width: 100%"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="number"
                label="发车批次号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="itemCategoryName"
                label="费项类型"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="itemServiceName"
                label="费项"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="objectStatus"
                label="结算对象类型"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="objectName"
                label="结算对象"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="amount"
                label="金额"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="paymentMethod"
                label="付款方式"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="applyReimburseStatus"
                label="是否申请报销"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="expenseNumber"
                label="报销单号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="dispatchRemarks"
                label="发车备注"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="remarks"
                label="备注"
              ></el-table-column>
              <el-table-column fixed="right" prop="cccc" label="图片">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.fileList && scope.row.fileList.length > 0"
                    class="lookImgs"
                    @click="lookBaseImgs(scope.row.fileList)"
                  >
                    查看图片
                  </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <div class="iconList">
                    <el-button class="tbBtns" @click="edit8(scope.row)"
                      >编辑</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- 弹窗 添加应收 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="itemCategoryId"
            label="费项类型:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.itemCategoryId"
              placeholder="请选择"
              @change="changeItemCategoryIdA"
            >
              <el-option
                v-for="(item, index) in categoryNameList"
                :key="index"
                :label="item.categoryName"
                :value="item.categoryId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="itemServiceId"
            label="费项:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.itemServiceId"
              placeholder="请选择"
              @change="changeItemServiceId"
            >
              <el-option
                v-for="(item, index) in CategoryServiceList"
                :key="index"
                :label="item.title"
                :value="item.itemServiceId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input
              v-model="dialogForm.amount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 添加应付 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogForm2Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm2Ref"
          v-if="isShowDialog2"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            class="dialogFormItems"
            prop="inoutStatus"
            label="收支类型:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm2.inoutStatus"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="(item, index) in inoutStatusList"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="inoutStatus"
            label="垫付人:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm2.applyEmployeeId"
              placeholder="请选择"
              remote
              :remote-method="
                (val) => {
                  getemployee(val);
                }
              "
              @focus="getemployee()"
              @change="changeEM"
            >
              <el-option
                v-for="(item, index) in employeeList"
                :key="index"
                :label="item.name"
                :value="Number(item.documentId)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="paymentMethodConfDictId"
            label="付款方式:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm2.paymentMethodConfDictId"
              placeholder="请选择"
              @change="changePayMent"
            >
              <el-option
                v-for="(item, index) in settlementMethodList"
                :key="index"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 450px"
            class="dialogFormItems"
            prop="objectStatusConfDictId"
            label="结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectStatusConfDictId"
                placeholder="请选择"
                @change="changeObjestStatus"
              >
                <el-option
                  v-for="(item, index) in objectStatusList"
                  :key="index"
                  :label="item.val"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectName"
                placeholder="请选择"
                :allow-create="dialogForm2.objectStatusType == 'other'"
                remote
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <div
            v-for="(itemA, idxA) in dialogForm2.itemCategoryList"
            :key="idxA"
            class="feeLists"
          >
            <el-form-item
              class="dialogFormItems"
              label="费项:"
              style="width: 450px"
            >
              <div class="multipleSelect">
                <el-select
                  filterable
                  clearable
                  v-model="itemA.itemCategoryId"
                  placeholder="请选择"
                  @change="changeItemCategoryIdYF($event, idxA)"
                >
                  <el-option
                    v-for="(item, index) in itemA.categoryNameList"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  ></el-option>
                </el-select>
                <el-select
                  allow-create
                  filterable
                  clearable
                  v-model="itemA.itemServiceId"
                  placeholder="请选择"
                  @change="changeItemServiceId2($event, idxA)"
                >
                  <el-option
                    v-for="(item, index) in itemA.CategoryServiceList"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item
              class="dialogFormItems"
              required
              label="金额:"
              style="width: 200px"
            >
              <el-input
                v-model="itemA.amount"
                type="number"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <div class="glo_disflex" v-if="dialogType2 !== 'edit'">
              <i
                v-if="idxA == 0"
                @click="addItemCater()"
                class="el-icon-circle-plus icons"
              ></i>
              <i
                @click="removeItemCater(idxA)"
                class="el-icon-remove icons"
              ></i>
            </div>
          </div>

          <!-- <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input
              v-model="dialogForm2.amount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>-->
          <el-form-item label="图片:" style="width: 100%">
            <uploadimgs
              @input="changeFileList6"
              :fileNameLists="fileNameLists6"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>

          <div style="padding-bottom: 16px; color: red; line-height: 24px">
            <aside>垫付人：实际垫付费用出去的人员</aside>
            <aside>结算对象：垫付人先垫付的费用实际是支付给谁的</aside>
          </div>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 收件人地址 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3"
    >
      <div class="glo_dialogForm">
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            v-if="isShowDialog3"
            :model="queryData"
            class="glo_form"
            label-position="left"
          >
            <el-form-item class="queryItems" label="单位/仓库:">
              <el-input
                clearable
                v-model="queryData.deptName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="联系人:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item class="queryItems" label="联系电话:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>-->
            <!-- <el-form-item class="queryItems" label="收发类型:">
              <el-select
                filterable
                clearable
                v-model="queryData.addressType"
                placeholder="请输入"
                disabled
              >
                <el-option
                  label="发件"
                  value="ji_jian:address_type"
                ></el-option>
                <el-option
                  label="收件"
                  value="shou_jian:address_type"
                ></el-option>
              </el-select>
            </el-form-item>-->
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="getCustomerAddrList"
              >查询</el-button
            >
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in addressTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" min-width="100px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="changeAddress(scope.row)"
                    >选择</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>

    <!-- 弹窗 客户弹窗 -->
    <myDialog
      :diaWidth="diaWidth4"
      :dialogTitle="dialogTitle4"
      :isShowDialog="isShowDialog4"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia4"
      @diaCancelBtn="handleCloseDia4"
      @diaConfirmBtn="diaConfirmBtn4"
    >
      <div class="glo_dialogForm">
        <!-- 查询条件 -->
        <div ref="queryForm4">
          <el-form
            v-if="isShowDialog4"
            :model="queryData4"
            class="glo_form"
            label-position="left"
          >
            <el-form-item class="queryItems" label="客户名称:">
              <el-input
                clearable
                v-model="queryData4.customerName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerList()"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item class="queryItems" label="业务员:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="联系人:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerList()"
              ></el-input>
            </el-form-item>-->

            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="getCustomerList"
              >查询</el-button
            >
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="CustomerLists"
            border
            stripe
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in customerTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column fixed="left" label="操作" min-width="100px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="changeCustomer(scope.row)"
                    >选择</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>

    <!-- 弹窗 提货单 -->
    <myDialog
      :diaWidth="diaWidth5"
      :dialogTitle="dialogTitle5"
      :isShowDialog="isShowDialog5"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia5"
      @diaCancelBtn="handleCloseDia5"
      @diaConfirmBtn="diaConfirmBtn5"
    >
      <div class="glo_dialogForm">
        <div class="queryBtnsList">
          <!-- 查询条件 -->
          <queryCondition
            ref="queryForm5"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
          ></queryCondition>
          <el-button class="queryBts" @click="getData()">查询</el-button>
        </div>

        <div class="glo_Table">
          <el-table
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="TiHuoTableData"
            border
            stripe
            @selection-change="handleSelectionChange5"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <!-- <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>-->
            <template v-for="(item, index) in TiHuoTableheardList">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column fixed="left" label="操作" min-width="100px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="changecommandId(scope.row)"
                    >选择</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>

    <!-- 弹窗 规格 -->
    <myDialog
      :diaWidth="diaWidth6"
      :dialogTitle="dialogTitle6"
      :isShowDialog="isShowDialog6"
      :showConfirm="true"
      :showCacel="false"
      @handleCloseDia="handleCloseDia6"
      @diaCancelBtn="handleCloseDia6"
      @diaConfirmBtn="diaConfirmBtn6"
    >
      <!-- 规格表格 -->
      <div class="huoWuBox">
        <div
          class="glo_Table goodsTable"
          v-for="(itemA, idx2) in goodsInfoList[0].itemReqs"
          :key="idx2"
        >
          <div class="addBTnsa">
            <el-button
              class="glo_bgcMainColor saveBtnsAddGG"
              @click="addGG(0, idx2)"
              >添加规格</el-button
            >
          </div>
          <el-table
            :data="goodsInfoList[0].itemReqs[idx2].itemSpecsReqs"
            border
            class="speckTable"
            style="width: 100%"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>

            <el-table-column
              show-overflow-tooltip
              prop="length"
              label="*长(cm)"
            >
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="
                    goodsInfoList[0].itemReqs[idx2].itemSpecsReqs[scope.$index]
                      .length
                  "
                  placeholder="请输入"
                  filterable
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="wide" label="*宽(cm)">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="
                    goodsInfoList[0].itemReqs[idx2].itemSpecsReqs[scope.$index]
                      .wide
                  "
                  placeholder="请输入"
                  filterable
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="height"
              label="*高(cm)"
            >
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="
                    goodsInfoList[0].itemReqs[idx2].itemSpecsReqs[scope.$index]
                      .height
                  "
                  placeholder="请输入"
                  filterable
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="packageCout"
              label="*件数"
            >
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="
                    goodsInfoList[0].itemReqs[idx2].itemSpecsReqs[scope.$index]
                      .packageCout
                  "
                  placeholder="请输入"
                  filterable
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <div class="iconList">
                  <el-popconfirm
                    title="确定删除该行信息吗"
                    @confirm="delGoods(idx, idx2, scope.$index)"
                  >
                    <i slot="reference" class="el-icon-remove iconSize"></i>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>

    <!-- 大图预览 -->
    <el-dialog
      title="图片预览"
      :visible.sync="bigImgsShow"
      width="50%"
      center
      :close-on-click-modal="false"
    >
      <div class>
        <div v-for="(item, index) in srcList" :key="index">
          <el-image
            style="width: 180px; height: 180px; margin: 10px"
            :src="item"
            :preview-src-list="srcList"
          ></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="bigImgsShow = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <!-- 弹窗 外发编辑 -->
    <myDialog
      :diaWidth="diaWidth7"
      :dialogTitle="dialogTitle7"
      :isShowDialog="isShowDialog7"
      @handleCloseDia="handleCloseDia7"
      @diaCancelBtn="handleCloseDia7"
      @diaConfirmBtn="diaConfirmBtn7('dialogForm7Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm7Ref"
          v-if="isShowDialog7"
          :model="dialogForm7"
          label-width="100px"
        >
          <el-form-item class="dialogFormItems" label="实际运费:">
            <el-input
              v-model="dialogForm7.basicFreight"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" label="实际送货费:">
            <el-input
              v-model="dialogForm7.sendFee"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" label="实际其他费用:">
            <el-input
              v-model="dialogForm7.allOtherFee"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" label="实际费用合计:">
            <el-input
              v-model="dialogForm7.totalAmount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" label="外发备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm7.outgoingRemarks"
            ></el-input>
          </el-form-item>
          <!-- outgoingRemarks -->
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 发车编辑 -->
    <myDialog
      :diaWidth="diaWidth8"
      :dialogTitle="dialogTitle8"
      :isShowDialog="isShowDialog8"
      @handleCloseDia="handleCloseDia8"
      @diaCancelBtn="handleCloseDia8"
      @diaConfirmBtn="diaConfirmBtn8('dialogForm8Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm8Ref"
          v-if="isShowDialog8"
          :model="dialogForm8"
          label-width="100px"
        >
          <el-form-item class="dialogFormItems" label="收支类型:">
            <el-select
              filterable
              clearable
              v-model="dialogForm8.inoutStatus"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="(item, index) in inoutStatusList8"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dialogFormItems" label="付款方式:">
            <el-select
              filterable
              clearable
              v-model="dialogForm8.paymentMethodConfDictId"
              placeholder="请选择"
              @change="changePayMent"
            >
              <el-option
                v-for="(item, index) in settlementMethodList"
                :key="index"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" label="金额:">
            <el-input
              v-model="dialogForm8.amount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="width: 450px"
            class="dialogFormItems"
            label="结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm8.objectStatusConfDictId"
                placeholder="请选择"
                @change="changeObjestStatus8"
              >
                <el-option
                  v-for="(item, index) in objectStatusList"
                  :key="index"
                  :label="item.val"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm8.objectName"
                placeholder="请选择"
                :allow-create="dialogForm8.objectStatusType == 'other'"
                remote
                :remote-method="getObjectUserDownListYf8"
                @change="changeobjectName8"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF8"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 450px"
            class="dialogFormItems"
            label="费项:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm8.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryIdYF8"
              >
                <el-option
                  v-for="(item, index) in categoryNameList"
                  :key="index"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
              <el-select
                allow-create
                filterable
                clearable
                v-model="dialogForm8.itemServiceId"
                placeholder="请选择"
                @change="changeItemServiceId8"
              >
                <el-option
                  v-for="(item, index) in CategoryServiceList8"
                  :key="index"
                  :label="item.title"
                  :value="item.itemServiceId"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm8.remarks"
            ></el-input>
          </el-form-item>
          <div style="margin-left: 30px">
            <div style="margin-bottom: 10px">
              上传图片: (支持上传jpg/png文件)
            </div>
            <uploadimgs
              @input="changeFileList8"
              :fileNameLists="fileNameLists8"
              :limit="9"
            ></uploadimgs>
          </div>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import queryCondition from "@/components/queryCondition.vue";
export default {
  inject: ["reload"],
  components: {
    myDialog,
    uploadimgs,
    queryCondition,
  },
  data() {
    return {
      isShowDialog7: false,
      dialogTitle7: "外发编辑",
      dialogType7: "",
      diaWidth7: "70%",
      dialogForm7: {
        // 弹窗表单数据
        allOtherFee: "",
        basicFreight: "",
        sendFee: "",
        totalAmount: "",
        outgoingId: "",
        outgoingRemarks: "",
      },
      CustomerListsYF8: [],
      fileNameLists8: [],
      CategoryServiceList8: [],
      isShowDialog8: false,
      dialogTitle8: "发车编辑",
      dialogType8: "",
      diaWidth8: "70%",
      dialogForm8: {
        // 弹窗表单数据
        financeId: "",
        amount: "",
        inoutStatus: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        objectStatusType: "",
        paymentMethodConfDictId: "",
        remarks: "",
        fileIds: [],
      },
      // isPosting:false,
      employeeList: [],
      srcList: [], //打包明细图片列表
      bigImgsShow: false,
      WaybillOutgoingFinance: [],
      WaybillDispatchFinance: [],
      isShowDialog6: false,
      dialogTitle6: "规格设计",
      diaWidth6: "80%",

      pageType: "",
      activeNames: ["2", "3"],
      isHaseMore: true,
      // 下面是旧的(合世)
      amountIsAble: true,
      isTiHuoGuiHUa: true, //是否提货规划
      //提货信息
      transportPlanInfoReq: {
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        outgoingReceiveMethod: "",
        outgoingReceiveMethodConfDictId: "",
        outgoingSendMethod: "",
        outgoingSendMethodConfDictId: "",
        storageId: "",
        storageName: "",
        transportPlan: "ru_cang:transport_plan",
      },
      out_going_billing_method_list: [],
      CarrierLists: [],
      SuperiorRegionList: [], //省
      cityNameList: [], //市
      areaNameList: [], //区
      baseInForm: {
        isInsure: false,
        isRelatePickCommand: false,
        isSorting: false,
        takeStatus: "yi_ti_huo:take_status",
        takeUserId: "",
        arrivalArea: "",
        arrivalAreaCode: "",
        channelArrivalArea: "",
        channelArrivalAreaCode: "",
        declaredValue: "",
        declaredValueRate: "",
        declaredValue: "",
        channelId: "",
        commandId: "",
        commandNumber: "",
        // businessDate: "", //业务日期
        // businessDeptId: "", //业务部门id
        // businessId: "", //业务员id(员工表id)
        customerId: "", //客户id
        customerName: "", //客户名称
        customerNumber: "", //客户编号
        customerOrderNumber: "", //客户单号
        deliveryTime: "", //交货日期
        // endDeptId: "", //终端网点id
        // isReturnGoods: "0", //是否回头货 0=否 1=是
        // isWaitNoticeSend: "0", //等通知放货 0=否 1=是
        // outboundCarrierId: "", //外发承运商id
        receiveMethod: "", //收货方式
        receiveMethodConfDictId: "", //收货方式id(字典表id)
        remarks: "", //备注

        rnRequireConfDictId: "", //回单要求id
        rnRequireCount: "", //回单份数
        rnRequireName: "", //回单要求
        sendMethod: "", //交货方式
        sendMethodConfDictId: "", //送货方式id(字典表id)
        takeTime: "", //提货时间
        transportMethod: "",
        transportMethodConfDictId: "", //运输方式id(字典表id)
        waybillNumber: "", //运单号
        waybillType: "", //货物类型: kuai_jian:waybill_type=快件 pu_jian:waybill_type=普件
        // carrierName: "", //外发承运商
      },
      // 收件信息
      shouJiForm: {
        address: "",
        addressType: "shou:address_type",
        areaName: "",
        cityName: "",
        company: "",
        contacts: "",
        phone: "",
        provinceName: "",
        serialNumber: "1",
        tel: "",
      },
      // 财务应收
      CaiWuData: {
        againSendFee: "",
        agentAmount: "",
        allOtherFee: "",
        basicFreight: "",
        billingAmount: "",
        formulaBillingWeightId: "", //计费重量公式(计费方式)id(saas库维护的表)
        goodsDeductedAmoun: "",
        insuranceFee: "",
        itemServiceReqs: [],
        invoiceTaxPoint: "",
        isInvoice: "0",
        packageFee: "",
        receivedAmount: "",
        monthlyAmount: "",
        remarks: "",
        rnorderAmount: "",
        sendFee: "",
        senderAmount: "",
        settlementMethodConfDictId: "",
        takeFee: "",
        totalFreight: "",
        unLoadFee: "",
        upstairsFee: "",
        waitingFee: "",

        channelArrivalArea: "",
        channelArrivalAreaCode: "",
        channelId: "",
        channelName: "",
      },
      //基本信息
      rulesBaseInform: {
        // businessDate: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        // businessDeptId: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        // businessId: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        customerId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        customerName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        customerOrderNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        deliveryTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        // endDeptId: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        // isReturnGoods: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        // isWaitNoticeSend: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        receiveMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        sendMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        takeTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        transportMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        waybillNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        waybillType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        rnRequireConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },

      rulesGoods: {
        areaName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        cityName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        contacts: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        phone: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        provinceName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      rulesYS: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      rulesCaiWu: {
        settlementMethodConfDictId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      rules: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // 收件地址信息
      rulesAddress: {
        addressType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        areaName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        cityName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        provinceName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        company: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        contacts: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        phone: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      CustomerLists: [], //客户列表
      CustomerListsYF: [], //对象列表
      addressNaemList: [], //客户档案列表
      EmployeeList: [], //员工列表
      depList: [], //部门列表
      storageList: [], //网点列表
      transportModeList: [], //运输方式
      ReceivingMethodList: [], //提货方式
      channelIdList: [], //报价方式
      channelArrivalAreaList: [], //
      sendMethodList: [], //送货方式
      rnrderRequireList: [], //回单类型
      waybillTypeList: [], //货物类型
      objectStatusList: [], //结算对象类型
      settlementMethodList: [], //付款方式
      CustomerList: [], //
      OUTsendMethodList: [], //
      OUTTakeMethodList: [], //
      takeStatusList: [
        {
          val: "dai_ti_huo:take_status",
          name: "待提货",
        },
        {
          val: "yi_ti_huo:take_status",
          name: "已提货",
        },
      ],

      goodsInfoList: [
        {
          addressReq: {
            address: "",
            addressType: "",
            areaName: "",
            cityName: "",
            company: "",
            contacts: "",
            phone: "",
            provinceName: "",
            serialNumber: "",
            tel: "",
          },
          itemReqs: [
            {
              billingWeight: "",
              freight: "",
              goodsName: "",
              goodsNumber: "",
              grossWeight: "",
              itemCategoryCode: "",
              itemCategoryName: "",
              netWeight: "",
              packageCout: "",
              packageName: "",
              serialNumber: "",
              specs: "",
              unitPrice: "",
              volume: "",
              volumeWeight: "",
              volumeDivisor: "",
              CategoryList: [], //
              packageNameList: [], //
              itemSpecsReqs: [
                {
                  height: "",
                  length: "",
                  packageCout: "",
                  wide: "",
                },
              ],
            },
          ],
          isAutoAddr_jj: true,
        },
      ],
      // 财务应付
      financeOutInfoReqs: [
        // {
        //   amount: "",
        //   inoutStatus: "zhi_chu:deal_status", //收支类型 shou_ru:deal_status=收入 zhi_chu:deal_status=支出
        //   itemCategoryId: "",
        //   itemCategoryName: "",
        //   itemServiceId: "",
        //   itemServiceName: "",
        //   objectName: "",
        //   objectNumber: "",
        //   objectStatusConfDictId: "",
        //   paymentMethodConfDictId: "",
        //   remarks: "",
        // },
      ], // 应付表格
      CaiWuFeiXiang: [],
      // 弹窗===添加应收
      isShowDialog: false,
      dialogTitle: "",
      dialogType: "add",
      deitIdx: 0,
      diaWidth: "40%",
      dialogForm: {
        // 弹窗表单数据
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
      },

      rulesForm: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // 弹窗===添加应付
      isShowDialog2: false,
      dialogTitle2: "",
      dialogType2: "",
      editYfIdx: 0,
      diaWidth2: "70%",
      dialogForm2: {
        // 弹窗表单数据
        amount: "",
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethod: "", //付款方式名称(我自己加的)
        isExpenseShow: "否", //是否已申请报销(我自己加的)
        isExpense: 0, //
        operationType: "",
        id: "",
        applyEmployeeId: "",
        itemCategoryList: [
          {
            amount: 0,
            itemCategoryId: "",
            itemCategoryName: "",
            categoryNameList: [],
            CategoryServiceList: [],
            itemServiceName: "",
            itemServiceId: "",
          },
        ],
      },
      categoryNameList: [],
      CategoryServiceList: [],
      rulesForm2: {
        itemCategoryId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        itemServiceId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        objectStatusType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        paymentMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        amount: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      // 地址弹窗
      addressIdx: 0,
      isShowDialog3: false,
      dialogTitle3: "",
      diaWidth3: "80%",
      tableData: [],
      addressTableHeard: [
        {
          name: "单位/仓库",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系人",
          field: "personnelName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "所属网点",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "详细地址",
          field: "address",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      isShowDialog4: false,
      dialogTitle4: "客户列表",
      diaWidth4: "80%",
      customerTableHeard: [
        {
          name: "所属网点",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系人",
          field: "contactsName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "手机号",
          field: "phone",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "业务员",
          field: "salesmanName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],

      isShowDialog5: false,
      dialogTitle5: "选择提货单",
      diaWidth5: "80%",

      queryData: {
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      },
      queryData4: {
        customerName: "",
      },

      fileNameLists: [],
      CategoryList: [],
      packageNameList: [],
      selectTableData: [],
      selectTableData5: [],
      yesOrNoList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],
      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],
      inoutStatusList8: [
        {
          name: "收入",
          val: "shou_ru:inout_status",
        },
        {
          name: "支出",
          val: "zhi_chu:inout_status",
        },
      ],

      contactsId: "", //收货人id,已放弃不用

      isAutoAddr_sj: true,

      CarrierDeptListList: [],
      changeCarrierList: [],

      getAddress: "",
      getcity: "",
      types: "",
      reportFiledsNumber: "command_list", // 动态 条件、表头
      TiHuoTableheardList: [],
      TiHuoTableData: [],
      queryCondditionDatas: [], //查询列表动态数据
      isShowGuoZhang: true, //是否显示过账按钮
      delArrsFInList: [], //已删除的应付

      fileNameLists6: [],
    };
  },
  watch: {
    // "CaiWuData.formulaBillingWeightId": function (a, b) {
    //   if (a) {
    //     this.billWeightCalculationById();
    //   }
    // },
    // 到货区域
    "shouJiForm.provinceName": function(a, b) {
      // 重新计算合计运费
      this.baseInForm.arrivalArea =
        this.shouJiForm.provinceName +
        this.shouJiForm.cityName +
        this.shouJiForm.areaName;
    },
    // 到货区域
    "shouJiForm.cityName": function(a, b) {
      // 重新计算合计运费
      this.baseInForm.arrivalArea =
        this.shouJiForm.provinceName +
        this.shouJiForm.cityName +
        this.shouJiForm.areaName;
    },
    // 到货区域
    "shouJiForm.areaName": function(a, b) {
      // 重新计算合计运费
      this.baseInForm.arrivalArea =
        this.shouJiForm.provinceName +
        this.shouJiForm.cityName +
        this.shouJiForm.areaName;
    },
    // 监听基本运费
    "CaiWuData.basicFreight": function(a, b) {
      // 重新计算合计运费
      this.getTotalFreight();
    },
    // 监听合计运费
    "CaiWuData.totalFreight": function(a, b) {
      // 合计运费变化,重新计算税金
      // this.getTaxes();
      // 合计运费变化,重新计算开单金额
      // this.getBillingAmount();

      // 结算金额
      this.changeSettlementMethod(this.CaiWuData.settlementMethodConfDictId);
    },
    // 监听税金
    // "CaiWuData.taxes": function (a, b) {
    //   // 税金变化,重新开单金额
    //   this.getBillingAmount();
    // },
    // 监听其他费用
    "CaiWuData.allOtherFee": function(a, b) {
      // 重新计算合计运费
      this.getTotalFreight();
    },
    // 监听开单金额变化，根据付款方式计算
    "CaiWuData.billingAmount": function(a, b) {
      // 重新计算合计运费
      this.changeSettlementMethod(this.CaiWuData.settlementMethodConfDictId);
    },
    isTiHuoGuiHUa: function(a, b) {
      if (!a) {
        this.transportPlanInfoReq = {
          carrierDeptId: "",
          carrierDeptName: "",
          carrierId: "",
          carrierName: "",
          outgoingReceiveMethod: "",
          outgoingReceiveMethodConfDictId: "",
          outgoingSendMethod: "",
          outgoingSendMethodConfDictId: "",
          storageId: "",
          storageName: "",
          transportPlan: "",
        };
      }
    },
    // 监听 提货计划类型
    "transportPlanInfoReq.transportPlan": function(a, b) {
      if (a == "zhi_song:transport_plan") {
        // 直送
        this.transportPlanInfoReq.carrierDeptId = "";
        this.transportPlanInfoReq.carrierDeptName = "";
        this.transportPlanInfoReq.carrierId = "";
        this.transportPlanInfoReq.carrierName = "";
        this.transportPlanInfoReq.outgoingReceiveMethod = "";
        this.transportPlanInfoReq.outgoingReceiveMethodConfDictId = "";
        this.transportPlanInfoReq.outgoingSendMethod = "";
        this.transportPlanInfoReq.outgoingSendMethodConfDictId = "";
        this.transportPlanInfoReq.storageId = "";
        this.transportPlanInfoReq.storageName = "";
      }
      if (a == "ru_cang:transport_plan") {
        // 入仓
        this.transportPlanInfoReq.carrierDeptId = "";
        this.transportPlanInfoReq.carrierDeptName = "";
        this.transportPlanInfoReq.carrierId = "";
        this.transportPlanInfoReq.carrierName = "";
        this.transportPlanInfoReq.outgoingReceiveMethod = "";
        this.transportPlanInfoReq.outgoingReceiveMethodConfDictId = "";
        this.transportPlanInfoReq.outgoingSendMethod = "";
        this.transportPlanInfoReq.outgoingSendMethodConfDictId = "";
      }
      if (a == "wai_fa:transport_plan") {
        // 外发
        this.transportPlanInfoReq.storageId = "";
        this.transportPlanInfoReq.storageName = "";
      }
    },

    // goodsInfoList: {
    //   handler(a, b) {
    //     a.forEach((item) => {
    //       item.itemReqs.forEach((item2) => {
    //         if (this.types == "按毛重") {
    //           if (item2.grossWeight) {
    //             item2.billingWeight = item2.grossWeight;
    //           }
    //         }
    //         if (this.types == "按毛重") {
    //           if (item2.grossWeight) {
    //             item2.billingWeight = item2.grossWeight;
    //           }
    //         }
    //         if (this.types == "按净重") {
    //           if (item2.netWeight) {
    //             item2.billingWeight = item2.netWeight;
    //           }
    //         }
    //         if (this.types == "按件数") {
    //           if (item2.packageCout) {
    //             item2.billingWeight = item2.packageCout;
    //           }
    //         }
    //         if (this.types == "按体积") {
    //           if (item2.volume) {
    //             item2.billingWeight = item2.volume;
    //           }
    //         }
    //       });
    //     });
    //   },
    //   deep: true,
    // },
  },
  created() {
    this.getCategoryList(); // 获取品类
    this.getDeptList(); //  部门

    // 根据对象类型获取结算对象的下拉列表
    this.getObjectUserDownList("employee"); //获取员工列表
    // this.getObjectUserDownList("dept"); //获取部门列表
    this.getObjectUserDownList("storage"); //获取网点列表

    // 根据字典类型获取字典值下拉列表
    this.getConfDictValDownList("package_name"); //获取包装
    this.getConfDictValDownList("waybill_type"); //货物类型
    this.getConfDictValDownList("rn_order_require"); //回单类型
    this.getConfDictValDownList("send_method"); //送货方式
    this.getConfDictValDownList("receive_method"); //提货方式
    this.getConfDictValDownList("transport_method"); //运输方式
    this.getConfDictValDownList("settlement_method"); //付款方式
    // this.getConfDictValDownList("out_going_billing_method"); //计费方式
    this.runPageReportDetailsitemId("formula_billing_weight_down_list"); //计费方式
    this.getConfDictValDownList("object_status"); //结算对象类型

    this.itemCategorChoose(); //费型类型下拉列表
  },
  mounted() {
    this.getParentName("中华人民共和国"); //默认查到各省
    // this.getCarrierList(); // 获取承运商列表

    // 监听复杂对象数组
    this.$watch(
      "goodsInfoList",
      (newVal, oldVal) => {
        // 遍历 goodsInfoList 数组
        newVal.forEach((item, idxA) => {
          // 遍历 itemReqs 数组
          item.itemReqs.forEach((itemReq, idxB) => {
            // 监听 billingWeight 字段的变化
            this.$watch(
              () => itemReq.billingWeight,
              (newBillingWeight, oldBillingWeight) => {
                // 在这里处理 billingWeight 字段值的变化
                this.getGoodsTable(idxA, idxB);
              }
            );
            // 监听 unitPrice 字段的变化
            this.$watch(
              () => itemReq.unitPrice,
              (newBillingWeight, oldBillingWeight) => {
                // 在这里处理 unitPrice 字段值的变化
                this.getGoodsTable(idxA, idxB);
              }
            );
          });
        });
      },
      { deep: true }
    );
  },
  activated() {
    let waybillSplitId = this.$route.query.waybillSplitId || "";
    this.pageType = this.$route.query.pageType || "";
    if (this.pageType == "buLu") {
      this.isShowGuoZhang = false;
    } else {
      this.isShowGuoZhang = true;
    }

    if (waybillSplitId) {
      this.waybillSplitId = waybillSplitId;
      this.getPackageDetails(); //  获取运单详情
      this.getWaybillFinance(); // 获取运单财务信息

      this.getWaybillDispatchFinance();
      this.getWaybillOutgoingFinance();
    }
  },
  destroyed() {},
  methods: {
    // 选择图片
    changeFileList6(array) {
      this.fileNameLists6 = array;
    },
    updateWaybillFinanceOut() {
      // 运单财务应付信息
      let financeOutInfoReqs = JSON.parse(
        JSON.stringify(this.financeOutInfoReqs)
      );
      financeOutInfoReqs.forEach((item) => {
        delete item.objectStatusType;
        delete item.paymentMethod;
        item.amount = item.amount || 0;
      });

      let fileIds = [];
      this.fileNameLists6.forEach((item) => {
        fileIds.push(item.name);
      });
      financeOutInfoReqs = [...financeOutInfoReqs, ...this.delArrsFInList];
      financeOutInfoReqs.forEach((item) => {
        if (item.operationType != "UNCHANGED") {
          item.fileIds = fileIds;
        }
      });
      let param = {
        financeOutInfoReqs: financeOutInfoReqs || [],
        waybillSplitId: this.waybillSplitId,
      };
      this.$API.updateWaybillFinanceOut(param).then((res) => {
        this.isShowDialog2 = false;

        // 重新获取接口的应付数据
        this.$API
          .wtl_getWaybillFinance({
            waybillSplitId: this.waybillSplitId,
          })
          .then((res) => {
            let datas = res.data.result || "";
            // this.CaiWuData = JSON.parse(JSON.stringify(datas.financeInInfoVo));
            // // this.isPosting = datas.financeInInfoVo.isPosting == 1 ? true : false;
            // this.CaiWuData.itemServiceReqs =
            //   datas.financeInInfoVo.itemServiceVos;
            // this.CaiWuData.settlementMethodConfDictId =
            //   datas.financeInInfoVo.settlementMethodConfDictId;
            // this.CaiWuData.delItemServiceReqs = [];
            // this.CaiWuData.itemServiceReqs.forEach((item) => {
            //   item.operationType = "UPDATE";
            // });
            // this.changeSettlementMethod(
            //   this.CaiWuData.settlementMethodConfDictId
            // );
            // 应付  isExpense
            this.delArrsFInList = [];
            let listA = datas.financeOutinfoVos || [];
            listA.forEach((item) => {
              if (item.isExpense == 1) {
                item.operationType = "UNCHANGED";
              } else {
                item.operationType = "UPDATE";
              }
            });
            this.financeOutInfoReqs = listA;
          });
      });
    },

    // 运单图片
    lookBaseImgs(arr) {
      this.srcList = arr.map((item) => {
        return item.url || item.fileUrl;
      });
      this.bigImgsShow = true;
    },
    //  获取运单发车批次应付财务信息
    getWaybillDispatchFinance() {
      this.$API
        .getWaybillDispatchFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || {};
          this.WaybillDispatchFinance = datas.financeOutVos || [];
        });
    },
    //  获取外发应付财务信息
    getWaybillOutgoingFinance() {
      this.$API
        .getWaybillOutgoingFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || [];
          this.WaybillOutgoingFinance = datas || [];
        });
    },

    // 运费计算(自定义选择报价)
    billWeightCalculationById() {
      if (!this.CaiWuData.formulaBillingWeightId) {
        return false;
      }
      let grossWeight = 0;
      let netWeight = 0;
      let packageCount = 0;
      let volume = 0;
      this.goodsInfoList.forEach((item) => {
        item.itemReqs.forEach((item2) => {
          grossWeight = this.$TOOLS.add(
            grossWeight,
            item2.grossWeight * 1 || 0
          );
          netWeight = this.$TOOLS.add(netWeight, item2.netWeight * 1 || 0);
          packageCount = this.$TOOLS.add(
            packageCount,
            item2.packageCout * 1 || 0
          );
          volume = this.$TOOLS.add(volume, item2.volume * 1 || 0);
        });
      });
      let param = {
        formulaBillingWeightId: this.CaiWuData.formulaBillingWeightId,
        grossWeight: grossWeight,
        netWeight: netWeight,
        packageCount: packageCount,
        volume: volume,
        channelOfferId: this.baseInForm.channelArrivalAreaCode,
      };
      this.$API.billWeightCalculationById(param).then((res) => {
        // billingWeight
        let datas = res.data.result || {};
        this.goodsInfoList[0].itemReqs[0].billingWeight =
          datas.billingWeight || 0; //计费取值
      });
    },

    changeChannel(e) {
      this.channelArrivalAreaList = [];
      this.baseInForm.channelArrivalAreaCode = "";
      this.baseInForm.channelArrivalArea = "";
      this.CaiWuData.formulaBillingWeightId = "";
      this.channelIdList.forEach((item) => {
        if (item.channelId == e) {
          // 获取计费方式
          this.CaiWuData.formulaBillingWeightId =
            item.formulaBillingWeightId + "";

          // 根据客户id获取报价到货区域
          let array2 = [
            {
              conditonKey: "channelId",
              conditonVal: item.channelId,
            },
          ];
          this.runPageReportDetailsitemId(
            "customer_dispatch_channel_down_list",
            array2
          );
        }
      });
    },
    // 改变到货区域
    changeChannelArrivalArea(e) {
      if (e) {
        this.channelArrivalAreaList.forEach((item) => {
          if (item.channelOfferId == e) {
            this.baseInForm.channelArrivalArea = item.offerName;
          }
        });
        this.freightCalculationById();
      }
    },

    // 运费计算(自定义选择报价)
    freightCalculationById() {
      let grossWeight = 0;
      let netWeight = 0;
      let packageCount = 0;
      let volume = 0;
      this.goodsInfoList.forEach((item) => {
        item.itemReqs.forEach((item2) => {
          grossWeight += item2.grossWeight || 0;
          netWeight += item2.netWeight || 0;
          packageCount += item2.packageCount || 0;
          volume += item2.volume || 0;
        });
      });
      let param = {
        channelId: this.baseInForm.channelId,
        grossWeight: grossWeight,
        netWeight: netWeight,
        packageCount: packageCount,
        volume: volume,
        channelOfferId: this.baseInForm.channelArrivalAreaCode,
      };
      console.log("param", param);
      this.$API.freightCalculationById(param).then((res) => {
        let resultS = res.data.result || {};
        console.log("resultS", resultS);
        let goodsList = JSON.parse(JSON.stringify(this.goodsInfoList)) || [];
        if (goodsList.length > 0) {
          goodsList[0].itemReqs[0].billingWeight = resultS.billingWeight || 0;
          goodsList[0].itemReqs[0].unitPrice = resultS.offerAmount || 0;
          goodsList[0].itemReqs[0].freight = resultS.freight || 0;
          goodsList[0].itemReqs[0].volumeWeight = resultS.volumeWeight || 0;
          goodsList[0].itemReqs[0].volumeDivisor = resultS.volumeDivisor || 0;
          goodsList[0].itemReqs[0].weightVolume = resultS.weightVolume || 0;
          this.goodsInfoList = goodsList;
          this.baseInForm.channelId = resultS.channelId;
          this.baseInForm.channelName = resultS.channelName;
          this.baseInForm.channelArrivalAreaCode = resultS.channelOfferId;
          this.baseInForm.channelArrivalArea = resultS.channelOfferName;
          this.CaiWuData.formulaBillingWeightId =
            resultS.formulaBillingWeightId;
          this.CaiWuData.formulaBillingWeightName =
            resultS.formulaBillingWeightName;

          this.CaiWuData.basicFreight = resultS.freight;
          this.CaiWuData.sendFee = resultS.sendAmount;
        }
      });
    },

    // 动态接口获取下拉列表
    runPageReportDetailsitemId(number, array) {
      this.$API
        .runPageReportDetails({
          number: number,
          conditionReqs: array || [],
        })
        .then((res) => {
          let datas = res.data.result.datas || [];
          if (number == "customer_channel_down_list") {
            // 客户报价方式下拉列表
            this.channelIdList = datas;
          }
          if (number == "customer_dispatch_channel_down_list") {
            // 报价到货区域
            this.channelArrivalAreaList = datas;
          }
          if (number == "formula_billing_weight_down_list") {
            // 计费方式
            this.out_going_billing_method_list = datas;
          }
        });
    },

    handleCloseDia6() {
      this.isShowDialog6 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn6() {
      this.isShowDialog6 = false;
    },
    // 清除提货单
    clearComman() {
      this.baseInForm.commandId = "";
      this.baseInForm.commandNumber = "";
    },
    // 清除客户
    clearCustomer() {
      this.baseInForm.customerName = "";
      this.baseInForm.customerId = "";
    },

    getData() {
      let params = {
        pageStart: 1,
        pageTotal: 100,
        number: this.reportFiledsNumber,
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result.datas || {};
          this.className = datas.className || "";
          this.TiHuoTableData = datas.data || [];
          this.pageCount = datas.pageCount || 0;
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },
    // 获取提货指令
    async getQueryList() {
      // 获取查询条件 list
      await this.$API
        .getReportConditions({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          if (datas && datas.length > 0) {
            datas.map((n) => (n.conditonVal = ""));
            let arrs = datas.filter((n) => {
              return n.textBoxType === "datetime";
            });
            let timeobjs = {};
            arrs.forEach((item) => {
              let { sort, conditonKeyShow } = item;
              let name = conditonKeyShow.includes("起始")
                ? conditonKeyShow.split("起始").join("")
                : conditonKeyShow.split("结束").join("");
              if (!timeobjs[sort]) {
                timeobjs[sort] = {
                  sort,
                  name,
                  children: [],
                };
              }
              timeobjs[sort].children.push(item);
            });
            let gdates = [];
            let dates = Object.values(timeobjs);
            if (dates.length) {
              gdates = [
                {
                  textBoxType: "datetime",
                  startTime_a: this.$TOOLS.getFlexDate(this.$COMMON.timeNum),
                  endTime_a: this.$TOOLS.getCurrentDate(),
                  timeType: "0",
                  timeTypes: dates.map((n, i) => {
                    return { value: String(i), label: n.name };
                  }),
                  timeChilds: dates.map((n, i) => {
                    return { sort: n.sort, name: n.name, children: n.children };
                  }),
                },
              ];
            }
            let arrsConddition = [];
            arrsConddition = [
              ...gdates,
              ...datas.filter((n) => {
                return n.textBoxType !== "datetime";
              }),
            ];

            // 获取 每个查询条件 的下拉数据
            arrsConddition.forEach(async (element, index) => {
              let { textBoxType } = element;
              if (textBoxType == "select") {
                element.selectOptions = [];
              }
            });
            this.queryCondditionDatas = arrsConddition;
            setTimeout(() => {
              this.getData();
            }, 0);
          }
        });
    },
    getHeardTable() {
      this.$API
        .getReportFileds({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          let lists = [];
          datas.forEach((element) => {
            lists.push({
              name: element.fieldNameShow,
              field: element.fieldAlias,
              width: element.wide,
              isTotal: element.isSum,
              sort: element.sort,
              isShow: true,
              isSort: true,
            });
          });
          this.TiHuoTableheardList = lists;
        });
    },
    // 选择或者清除客户时触发
    changeCustomer(e) {
      let names = e.customerName || "";
      if (!names) {
        this.getCustomerList();
        this.baseInForm.customerId = "";
      } else {
        this.CustomerLists.forEach((item) => {
          if (item.customerName == names) {
            this.baseInForm.customerName = names;
            this.baseInForm.customerId = item.customerId;
            this.getCustomerDefaultAddrList(this.baseInForm.customerId);
            this.baseInForm.businessId = item.salesmanId || "";
            this.baseInForm.businessDeptId = item.deptId || "";

            this.settlementMethodList.forEach((itemA) => {
              if (itemA.val == item.settlementMethod) {
                this.CaiWuData.settlementMethodConfDictId = itemA.confDictId;
              }
            });
          }
        });
      }
      this.isShowDialog4 = false;
      this.queryData4.customerName = "";
    },
    // 添加费项
    addItemCater() {
      let objs = {
        itemCategoryId: "",
        itemCategoryName: "",
        amount: 0,
        categoryNameList: this.categoryNameList || [],
        CategoryServiceList: [],
        itemServiceName: "",
        itemServiceId: "",
      };
      this.dialogForm2.itemCategoryList.push(objs);
    },
    removeItemCater(idx) {
      this.$confirm("是否删除所选费项?", "提示:")
        .then(() => {
          let arrs = JSON.parse(JSON.stringify(this.dialogForm2)) || [];
          arrs.itemCategoryList.splice(idx, 1);
          this.dialogForm2 = arrs;
        })
        .catch((err) => {});
    },

    // 新建规格
    addGG(idx, idx2) {
      let obj = {
        height: "",
        length: "",
        packageCout: "",
        wide: "",
      };
      let arrs = JSON.parse(JSON.stringify(this.goodsInfoList)) || [];
      let arrs2 = arrs[idx].itemReqs[idx2].itemSpecsReqs || [];
      arrs2.push(obj);
      arrs[idx].itemReqs[idx2].itemSpecsReqs = arrs2;
      this.goodsInfoList = arrs;
    },

    // 选择计费方式自动填充计费重量
    changeBILLMethode(e) {
      if (e) {
        this.billWeightCalculationById();
        // this.out_going_billing_method_list.forEach((item) => {
        //   if (item.confDictId == e) {
        //     let types = item.key;
        //     this.types = types; //外发计费方式
        //     let datas = JSON.parse(JSON.stringify(this.goodsInfoList));
        //     datas.forEach((item) => {
        //       item.itemReqs.forEach((item2, index) => {
        //         if (types == "按毛重") {
        //           if (item2.grossWeight) {
        //             item2.billingWeight = item2.grossWeight;
        //           }
        //         }
        //         if (types == "按毛重") {
        //           if (item2.grossWeight) {
        //             item2.billingWeight = item2.grossWeight;
        //           }
        //         }
        //         if (types == "按净重") {
        //           if (item2.netWeight) {
        //             item2.billingWeight = item2.netWeight;
        //           }
        //         }
        //         if (types == "按件数") {
        //           if (item2.packageCout) {
        //             item2.billingWeight = item2.packageCout;
        //           }
        //         }
        //         if (types == "按体积") {
        //           if (item2.volume) {
        //             item2.billingWeight = item2.volume;
        //           }
        //         }
        //       });
        //     });
        //     this.goodsInfoList = datas;
        //   }
        // });
      }
    },
    // 收货地址（自动识别地址
    geocode(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.shouJiForm));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.shouJiForm = sj;
      });
    },
    // 发货地址（自动识别
    geocodeFH(getAddress, idx) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let val = JSON.parse(JSON.stringify(this.goodsInfoList));
        val[idx].addressReq.provinceName = datas.province;
        val[idx].addressReq.cityName = datas.city;
        val[idx].addressReq.areaName = datas.district;
        this.goodsInfoList = val;
      });
    },
    changeTH(e) {
      this.transportPlanInfoReq.outgoingReceiveMethod = "";
      if (e) {
        this.OUTTakeMethodList.forEach((element) => {
          if (element.confDictId == e) {
            this.transportPlanInfoReq.outgoingReceiveMethod = element.val;
          }
        });
      }
    },
    changeSH(e) {
      this.transportPlanInfoReq.outgoingSendMethod = "";
      if (e) {
        this.OUTsendMethodList.forEach((element) => {
          if (element.confDictId == e) {
            this.transportPlanInfoReq.outgoingSendMethod = element.val;
          }
        });
      }
    },
    // 承运商列表
    getchangeCarrier(e) {
      this.$COMAPI.changeCarrier(e).then((res) => {
        this.changeCarrierList = res || [];
      });
    },
    // 选择承运商(外发)
    changecarrierName2(e) {
      this.transportPlanInfoReq.carrierDeptId = "";
      this.transportPlanInfoReq.carrierId = "";
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierName == e) {
            this.transportPlanInfoReq.carrierId = item.carrierId;
            this.getCarrierDeptList(item.carrierId);
          }
        });
      }
    },
    // 登录账号的承运商默认网点
    changeCarrierDeptName(e) {
      this.transportPlanInfoReq.carrierDeptName = "";
      if (e) {
        this.CarrierDeptListList.forEach((item) => {
          if (item.carrierDeptId == e) {
            this.transportPlanInfoReq.carrierDeptName = item.deptName;
          }
        });
      }
    },
    // 获取承运商网点
    getCarrierDeptList(id) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.CarrierDeptListList = res || [];
      });
    },

    // 获取运单财务信息
    getWaybillFinance() {
      this.$API
        .wtl_getWaybillFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || "";
          this.CaiWuData = JSON.parse(JSON.stringify(datas.financeInInfoVo));
          // this.isPosting = datas.financeInInfoVo.isPosting == 1 ? true : false;
          this.CaiWuData.itemServiceReqs = datas.financeInInfoVo.itemServiceVos;
          this.CaiWuData.settlementMethodConfDictId =
            datas.financeInInfoVo.settlementMethodConfDictId;
          this.CaiWuData.delItemServiceReqs = [];
          this.CaiWuData.itemServiceReqs.forEach((item) => {
            item.operationType = "UPDATE";
          });
          this.changeSettlementMethod(
            this.CaiWuData.settlementMethodConfDictId
          );
          // 应付
          this.financeOutInfoReqs = datas.financeOutinfoVos;
          this.financeOutInfoReqs.forEach((item) => {
            // item.operationType = "UPDATE";
            if (item.isExpense == 1) {
              item.operationType = "UNCHANGED";
            } else {
              item.operationType = "UPDATE";
            }
          });
        });
    },

    //  获取运单详情
    getPackageDetails() {
      this.$API
        .wtl_getWaybillDetail({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result;
          // 基本信息
          this.baseInForm = datas.baseInfoVo;
          // this.baseInForm.isReturnGoods = this.baseInForm.isReturnGoods + "";
          // this.baseInForm.isWaitNoticeSend =
          //   this.baseInForm.isWaitNoticeSend + "";
          this.baseInForm.carrierName = this.baseInForm.outboundCarrierName;
          this.baseInForm.isSorting =
            this.baseInForm.isSorting == 1 ? true : false;
          this.baseInForm.isRelatePickCommand =
            this.baseInForm.isRelatePickCommand == 1 ? true : false;
          this.baseInForm.isInsure =
            this.baseInForm.isInsure == 1 ? true : false;
          // this.baseInForm.waybillNumber = "";
          // this.baseInForm.customerOrderNumber =this.baseInForm.customereOrderNumber;
          // this.baseInForm.outboundCarrierId =
          //   this.baseInForm.outboundCarrierId + "";

          let takeStatusVal = this.baseInForm.takeStatus || "";
          if (!takeStatusVal) {
            this.baseInForm.takeStatus = "yi_ti_huo:take_status";
          }

          // 收件人信息
          this.shouJiForm = datas.receiveAddressVo;
          this.shouJiForm.operationType = "UPDATE";
          this.getCityName(this.shouJiForm.provinceName); //获取市下拉列表
          this.getAreaName(this.shouJiForm.cityName); //获取区下拉列表

          // 货物信息
          let arrs = [];
          datas.takeAddressVos.forEach((item, index) => {
            //处理提货地址
            let obj = item.addressVo;
            obj.cityNameList = [];
            obj.areaNameList = [];
            this.getCityNameFH(obj.provinceName, index);
            this.getAreaNameFH(obj.cityName, index);
            obj.operationType = "UPDATE";
            obj.addressId = obj.addrId;
            obj.addrId = obj.addrId;
            // delete obj.addrId;
            // 处理货物信息
            let array = item.itemVos;
            array.forEach((item2) => {
              // 品类和包装
              item2.CategoryList = JSON.parse(
                JSON.stringify(this.CategoryList || [])
              );
              item2.packageNameList = JSON.parse(
                JSON.stringify(this.packageNameList || [])
              );
              item2.operationType = "UPDATE";
              item2.addressId = item2.addrId;
              item2.addrId = item2.addrId;
              // item2.goodsId = item2.itemId;
              // delete item2.addrId;
              // delete item2.itemId;
            });
            let items = {
              addressReq: obj,
              itemReqs: array,
              DelitemReqs: [],
            };
            arrs.push(items);
          });
          this.goodsInfoList = arrs;

          //图片信息
          let fileVoList = datas.fileVoList || [];
          let fileArrs = [];
          fileVoList.forEach((item) => {
            let objs = {
              name: item.fileName,
              url: item.url,
              operationType: "UPDATE",
            };
            fileArrs.push(objs);
          });
          this.fileVoListAll = fileArrs; //初始的图片
          this.fileNameLists = fileArrs; //显示的,

          // 根据客户id获取报价方式
          let array = [
            {
              conditonKey: "customerId",
              conditonVal: this.baseInForm.customerId,
            },
          ];
          this.runPageReportDetailsitemId("customer_channel_down_list", array);

          // 根据channelId获取报价到货区域
          let array2 = [
            {
              conditonKey: "channelId",
              conditonVal: this.baseInForm.channelId,
            },
          ];
          this.runPageReportDetailsitemId(
            "customer_dispatch_channel_down_list",
            array2
          );
        });
    },

    // 选择承运商
    // changeCarrier(e) {
    //   if (e) {
    //     this.CarrierLists.forEach((item) => {
    //       if (item.carrierName == e) {
    //         this.baseInForm.outboundCarrierId = item.carrierId;
    //       }
    //     });
    //   } else {
    //     this.getCarrierList();
    //   }
    // },
    // 获取承运商列表
    getCarrierList(carrierName) {
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || "",
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || [];
        });
    },
    // 选择结算方式
    changeSettlementMethod(e) {
      let val = "";
      this.settlementMethodList.forEach((item) => {
        if (item.confDictId == e) {
          val = item.key;
        }
      });
      this.amountIsAble = true;
      // console.log("val", val);
      // console.log("this.CaiWuData.billingAmount", this.CaiWuData.billingAmount);
      let billingAmount = this.CaiWuData.totalFreight || 0;
      if (val == "ji_fu_xian_jie") {
        //寄付现结
        this.CaiWuData.senderAmount = billingAmount || 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "dao_fu") {
        //到付
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = billingAmount || 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "ji_fu_yue_jie") {
        //寄付月结
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = billingAmount || 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "ji_fu_hui_dan_jie") {
        //寄付回单结
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = billingAmount || 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "duo_bi_fu") {
        //多笔付
        this.amountIsAble = false;
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "dai_shou_huo_kuan_kou") {
        //代收货款扣
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = billingAmount || 0; //货款扣运费
      } else if (val == "mian_fei") {
        //免费
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      }

      console.log("this.CaiWuData", this.CaiWuData);
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.SuperiorRegionList = res.data.result.data || [];
      });
    },
    // 获取市 (收货地址)
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityNameList = res.data.result.data || [];
        });
    },
    // 获取市 (收货地址)
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.areaNameList = res.data.result.data || [];
        });
    },
    // 获取市 (发货地址)
    getCityNameFH(e, idx) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          let arrs = JSON.parse(JSON.stringify(this.goodsInfoList));
          arrs[idx].cityNameList = res.data.result.data || [];
          this.goodsInfoList = arrs;
        });
    },
    // 获取市 (发货地址)
    getAreaNameFH(e, idx) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          let arrs = JSON.parse(JSON.stringify(this.goodsInfoList));
          arrs[idx].areaNameList = res.data.result.data || [];
          this.goodsInfoList = arrs;
        });
    },
    // 选择省(收货地址)
    changeProvince(e) {
      this.shouJiForm.cityName = "";
      this.shouJiForm.areaName = "";
      this.cityNameList = [];
      this.areaNameList = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.shouJiForm.areaName = "";
      this.areaNameList = [];
      if (e) {
        this.getAreaName(e);
      }
    },
    // 选择省查市(发货)
    changeProvinceFH(e, idx) {
      this.goodsInfoList[idx].addressReq.cityName = "";
      this.goodsInfoList[idx].addressReq.cityNameList = [];
      this.goodsInfoList[idx].addressReq.areaName = "";
      this.goodsInfoList[idx].addressReq.areaNameList = [];
      if (e) {
        this.getCityNameFH(e, idx);
      }
    },
    // 选择市查区(发货)
    changeCityFH(e, idx) {
      this.goodsInfoList[idx].addressReq.areaName = "";
      this.goodsInfoList[idx].addressReq.cityNameList = [];
      if (e) {
        this.getAreaNameFH(e, idx);
      }
    },
    // 计算货物信息表格的运费
    getGoodsTable(a, b) {
      let num1 = this.goodsInfoList[a].itemReqs[b].billingWeight || 0; //计费取值
      let num2 = this.goodsInfoList[a].itemReqs[b].unitPrice || 0; //单价
      this.goodsInfoList[a].itemReqs[b].freight = this.$TOOLS.mul(num1, num2);
      this.getBasicFreight();
    },
    // 税金
    // getTaxes() {
    //   let num1 = this.CaiWuData.totalFreight || 0; //运费合计
    //   let num2 = this.CaiWuData.invoiceTaxPoint || 0; //税点
    //   let num3 = this.$TOOLS.divide(num2, 100);
    //   this.CaiWuData.taxes = this.$TOOLS.mul(num1, num3).toFixed(2);
    // },
    // 计算:基本运费
    getBasicFreight() {
      let array = [];
      this.goodsInfoList.forEach((item) => {
        item.itemReqs.forEach((item2) => {
          array.push(item2.freight);
        });
      });
      this.CaiWuData.basicFreight = this.$TOOLS.getAddMathNumber(array);

      this.getTotalFreight();
    },

    getBXFee() {
      //  保险费=声明价值*费率
      let num = 0;
      let num1 = (this.baseInForm.declaredValue || 0) * 1; //声明价值
      let num2 = (this.baseInForm.declaredValueRate || 0) * 1; //费率
      let num3 = this.$TOOLS.divide(num2, 1000); //费率除1000
      num = this.$TOOLS.mathToFixed(this.$TOOLS.mul(num1, num3), 3) || 0;
      this.CaiWuData.insuranceFee = num;

      this.getTotalFreight();
    },
    // 计算:其他费用
    getOtherExpenses(arr) {
      let array = [];
      if (arr) {
        array = arr;
      } else {
        // 动态计算其他费用
        this.CaiWuData.itemServiceReqs.forEach((item) => {
          array.push(item.amount);
        });
      }

      this.CaiWuData.allOtherFee = this.$TOOLS.getAddMathNumber(array);
      this.getTotalFreight();
    },
    // 计算:开单金额
    getBillingAmount() {
      // let num1 = this.CaiWuData.totalFreight || 0; //运费合计
      // let num2 = this.CaiWuData.taxes || 0; //税金
      // let array = [num1, num2];
      // this.CaiWuData.billingAmount = this.$TOOLS.getAddMathNumber(array);
    },
    // 计算:运费合计
    getTotalFreight() {
      let num1 = this.CaiWuData.basicFreight || 0; //基本运费
      let num2 = this.CaiWuData.takeFee || 0; //提货费
      let num3 = this.CaiWuData.sendFee || 0; //送货费
      let num4 = this.CaiWuData.unLoadFee || 0; //装卸费
      let num5 = this.CaiWuData.insuranceFee || 0; //保险费
      let num6 = this.CaiWuData.allOtherFee || 0; //其他费用
      let num7 = this.CaiWuData.packageFee || 0; //包装费
      let num8 = this.CaiWuData.upstairsFee || 0; //upstairsFee
      let num9 = this.CaiWuData.waitingFee || 0; //等候费
      let num10 = this.CaiWuData.againSendFee || 0; //二次送货费
      let array = [num1, num2, num3, num4, num5, num6, num7, num8, num9, num10];

      this.CaiWuData.totalFreight = this.$TOOLS.getAddMathNumber(array);
    },

    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    //选择费项类型(应收)
    changeItemCategoryId(e) {
      if (e) {
        this.wtl_itemServiceListAllYS(e, "shou:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm.itemServiceId = "";
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },

    // 费型类型下拉列表
    itemCategorChooseA(categoryName, idx) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.dialogForm2.itemCategoryList[idx].categoryNameList =
            res.data.result || [];
          this.categoryNameList = res.data.result || [];
        });
    },
    //选择费项类型(应收)
    changeItemCategoryIdA(e) {
      this.dialogForm.itemServiceId = "";
      this.dialogForm.amount = "";
      this.dialogForm.itemServiceName = "";
      if (e) {
        this.wtl_itemServiceListAllYS(e, "shou:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm.itemCategoryName = item.categoryName;
          }
        });
      }
    },

    //选择费项
    changeItemServiceId(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm.amount = item.unitPrice;
            this.dialogForm.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    //选择费项类型(应付)
    changeItemCategoryIdYF(e, idx) {
      let datas = JSON.parse(JSON.stringify(this.dialogForm2)) || [];
      datas.itemCategoryList[idx].itemServiceId = "";
      datas.itemCategoryList[idx].amount = 0;
      datas.itemCategoryList[idx].itemServiceName = "";
      if (e) {
        this.wtl_itemServiceListAll(e, "fu:direction_status", idx);
        datas.itemCategoryList[idx].categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            datas.itemCategoryList[idx].itemCategoryName = item.categoryName;
          }
        });
      }
      this.dialogForm2 = datas;
    },
    // 选择结算对象类型
    changeObjestStatus(e) {
      this.dialogForm2.objectName = "";
      this.dialogForm2.objectNumber = "";
      this.dialogForm2.objectStatusType = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm2.objectStatusType = item.key;
            this.dialogForm2.objectStatus = item.val;
            // this.dialogForm2.objectStatusConfDictId = item.confDictId;
          }
        });
        this.getObjectUserDownListYf();
      }
    },
    // 选择结算对象类型
    changeObjestStatus8(e) {
      this.dialogForm8.objectName = "";
      this.dialogForm8.objectNumber = "";
      this.dialogForm8.objectStatusType = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm8.objectStatusType = item.key;
            // this.dialogForm8.objectStatus = item.val;
          }
        });
        this.getObjectUserDownListYf8();
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf8(name) {
      if (this.dialogForm8.objectStatusType) {
        this.$API
          .wtl_getObjectUserDownList({
            key: this.dialogForm8.objectStatusType || "",
            name: name || "",
            pageStart: 1,
            pageTotal: 200,
          })
          .then((res) => {
            this.CustomerListsYF8 = res.data.result.data || [];
          });
      }
    },
    changeobjectName8(e) {
      if (!e) {
        this.getObjectUserDownListYf8();
      } else {
        this.CustomerListsYF8.forEach((item) => {
          if (item.name === e) {
            this.dialogForm8.objectNumber = item.number;
            // this.dialogForm2.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    //选择费项类型(应付)
    changeItemCategoryIdYF8(e) {
      if (e) {
        this.wtl_itemServiceListAll8(e, "fu:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm8.itemCategoryName = item.categoryName;
          }
        });
      }
    },
    //选择费项(应付弹窗)
    changeItemServiceId8(e, idx) {
      if (e) {
        this.categoryNameList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm8.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm8.itemServiceName = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll8(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList8 = res.data.result || [];
        });
    },
    //选择费项(应付弹窗)
    changeItemServiceId2(e, idx) {
      let datas = JSON.parse(JSON.stringify(this.dialogForm2));
      if (e) {
        datas.itemCategoryList[idx].CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            datas.itemCategoryList[idx].amount = item.unitPrice;
            datas.itemCategoryList[idx].itemServiceName = item.title;
          }
        });
      } else {
        datas.itemCategoryList[idx].amount = 0;
        datas.itemCategoryList[idx].itemServiceName = "";
      }
      this.dialogForm2 = datas;
    },
    //选择付款方式(应付弹窗)
    changePayMent(e) {
      if (e) {
        this.settlementMethodList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm2.paymentMethod = item.val;
          }
        });
      }
      // else {
      //   this.dialogForm2.amount = "";
      //   this.dialogForm2.itemServiceName = "";
      // }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus, idx) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          let list = JSON.parse(JSON.stringify(this.dialogForm2));
          list.itemCategoryList[idx].CategoryServiceList =
            res.data.result || [];
          this.dialogForm2 = list;
        });
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAllYS(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },
    // 获取品类
    getCategoryList(categoryName) {
      this.$API
        .wtl_getCategoryList({
          categoryName: categoryName,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CategoryList = res.data.result.data || [];
          this.goodsInfoList[0].itemReqs[0].CategoryList = this.CategoryList;
        });
    },
    // 收-发货人列表
    getCustomerAddrList() {
      this.$API
        .wtl_getCustomerAddrList({
          customerId: this.queryData.customerId,
          addressType: this.queryData.addressType,
          deptName: this.queryData.deptName,
          personnelName: this.queryData.personnelName,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
        });
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 表格选择事件
    handleSelectionChange5(e) {
      this.selectTableData5 = e;
    },
    // 选择收件人地址
    changeRecAddress(type, idx) {
      if (type == 1) {
        this.dialogTitle3 = "选择收货地址";
        this.queryData.addressType = "shou_jian:address_type";
      } else {
        this.dialogTitle3 = "选择发货地址";
        this.queryData.addressType = "ji_jian:address_type";
        this.addressIdx = idx || 0;
      }
      this.queryData.customerId = this.baseInForm.customerId + "" || "";

      if (this.baseInForm.customerId) {
        this.isShowDialog3 = true;
        this.getCustomerListAddress();
        this.getCustomerAddrList();
      } else {
        if (this.baseInForm.customerName) {
          this.$message.warning("当前客户没有客户档案").showClose = true;
        } else {
          this.$message.warning("请先选择客户").showClose = true;
        }

        return false;
      }
    },
    // 选择地址
    changeAddress(row) {
      if (this.queryData.addressType == "ji_jian:address_type") {
        //寄件
        // this.goodsInfoList[this.addressIdx].z;
        this.goodsInfoList[this.addressIdx].addressReq.company =
          row.deptName || "";
        this.goodsInfoList[this.addressIdx].addressReq.contacts =
          row.personnelName || "";
        this.goodsInfoList[this.addressIdx].addressReq.phone = row.tel || "";
        this.goodsInfoList[this.addressIdx].addressReq.provinceName =
          row.provinceName || "";
        this.goodsInfoList[this.addressIdx].addressReq.cityName =
          row.cityName || "";
        this.goodsInfoList[this.addressIdx].addressReq.areaName =
          row.areaName || "";
        this.goodsInfoList[this.addressIdx].addressReq.address =
          row.address || "";
        this.isShowDialog3 = false;
        this.getCityNameFH(row.provinceName, this.addressIdx);
        this.getAreaNameFH(row.cityName, this.addressIdx);
      } else {
        //收件
        this.shouJiForm.company = row.deptName || "";
        this.shouJiForm.contacts = row.personnelName || "";
        this.shouJiForm.phone = row.tel || "";
        this.shouJiForm.provinceName = row.provinceName || "";
        this.shouJiForm.cityName = row.cityName || "";
        this.shouJiForm.areaName = row.areaName || "";
        this.shouJiForm.address = row.address || "";
        this.baseInForm.remarks = row.remarks || "";
        this.isShowDialog3 = false;

        this.getCityName(row.provinceName);
        this.getAreaName(row.cityName);
      }
    },

    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      return this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
            this.goodsInfoList[0].itemReqs[0].packageNameList = arrs;
          }
          if (dictType == "waybill_type") {
            // 货物类型
            this.waybillTypeList = arrs;
            arrs.forEach((item) => {
              if (item.key == "普货") {
                this.baseInForm.waybillType = item.key;
              }
            });
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
          if (dictType == "send_method") {
            // 获取送货方式列表
            this.sendMethodList = arrs;
            arrs.forEach((item) => {
              if (item.key == "送货上门") {
                this.baseInForm.sendMethodConfDictId = item.confDictId;
              }
            });
          }
          if (dictType == "receive_method") {
            // 获取收货方式列表
            this.ReceivingMethodList = arrs;
            arrs.forEach((item) => {
              if (item.key == "上门取货") {
                this.baseInForm.receiveMethodConfDictId = item.confDictId;
              }
            });
          }
          if (dictType == "transport_method") {
            // 获取运输方式列表
            this.transportModeList = arrs;
          }
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs;
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
          if (dictType == "out_going_send_method") {
            // 外发送货方式
            this.OUTsendMethodList = arrs;
          }
          if (dictType == "out_going_take_method") {
            // 外发提货
            this.OUTTakeMethodList = arrs;
          }
          if (dictType == "out_going_billing_method") {
            // 计费方式
            // this.out_going_billing_method_list = arrs;
          }
        });
    },
    // 运费计算(获取报价方式)
    freightCalculation() {
      console.log("运费计算", this.baseInForm.customerId);
      if (!this.baseInForm.customerId) {
        this.$message.error("请选择客户");
        return false;
      }

      let grossWeight = 0;
      let netWeight = 0;
      let packageCount = 0;
      let volume = 0;
      this.goodsInfoList.forEach((item) => {
        item.itemReqs.forEach((item2) => {
          grossWeight = this.$TOOLS.add(
            grossWeight,
            item2.grossWeight * 1 || 0
          );
          netWeight = this.$TOOLS.add(netWeight, item2.netWeight * 1 || 0);
          packageCount = this.$TOOLS.add(
            packageCount,
            item2.packageCount * 1 || 0
          );
          volume = this.$TOOLS.add(volume, item2.volume * 1 || 0);
        });
      });
      let goodsTypeConfDictId = "";
      this.waybillTypeList.forEach((item) => {
        if (item.key == this.baseInForm.waybillType) {
          goodsTypeConfDictId = item.confDictId;
        }
      });
      let param = {
        customerId: this.baseInForm.customerId || "",
        goodsTypeConfDictId: goodsTypeConfDictId,
        grossWeight: grossWeight || 0,
        netWeight: netWeight || 0,
        packageCount: packageCount || 0,
        transportMethodConfDictId: this.baseInForm.transportMethodConfDictId,
        volume: volume || 0,
        provinceName: this.shouJiForm.provinceName,
        address: this.shouJiForm.address,
        areaName: this.shouJiForm.areaName,
        cityName: this.shouJiForm.cityName,
        startAreaName: this.goodsInfoList[0]?.addressReq.areaName || "",
        startCityName: this.goodsInfoList[0]?.addressReq.cityName || "",
        startProvinceName: this.goodsInfoList[0]?.addressReq.provinceName || "",
      };

      this.$API.freightCalculation(param).then((res) => {
        let resultS = res.data.result || {};
        let goodsList = JSON.parse(JSON.stringify(this.goodsInfoList)) || [];
        if (goodsList.length > 0) {
          goodsList[0].itemReqs[0].billingWeight = resultS.billingWeight || 0;
          goodsList[0].itemReqs[0].unitPrice = resultS.offerAmount || 0;
          goodsList[0].itemReqs[0].freight = resultS.freight || 0;
          goodsList[0].itemReqs[0].volumeWeight = resultS.volumeWeight || 0;
          goodsList[0].itemReqs[0].volumeDivisor = resultS.volumeDivisor || 0;
          goodsList[0].itemReqs[0].weightVolume = resultS.weightVolume || 0;
          this.goodsInfoList = goodsList;
          this.baseInForm.channelId = resultS.channelId;
          this.baseInForm.channelName = resultS.channelName;
          // this.baseInForm.channelArrivalArea = resultS.channelOfferId;
          // this.baseInForm.channelOfferName = resultS.channelOfferName;
          this.baseInForm.channelArrivalAreaCode = resultS.channelOfferId;
          this.baseInForm.channelArrivalArea = resultS.channelOfferName;
          this.CaiWuData.formulaBillingWeightId =
            resultS.formulaBillingWeightId + "";
          this.CaiWuData.formulaBillingWeightName =
            resultS.formulaBillingWeightName;

          this.CaiWuData.basicFreight = resultS.freight;
          this.CaiWuData.sendFee = resultS.sendAmount;

          console.log("this.CaiWuData", this.CaiWuData);
          console.log("this.baseInForm", this.baseInForm);

          // 根据channelId获取报价到货区域
          let array2 = [
            {
              conditonKey: "channelId",
              conditonVal: this.baseInForm.channelId,
            },
          ];
          this.runPageReportDetailsitemId(
            "customer_dispatch_channel_down_list",
            array2
          );
        }
      });
    },
    // 选择交货方式
    changesendMethod(e) {
      this.sendMethodList.forEach((item) => {
        if (item.confDictId == e) {
          this.baseInForm.sendMethod = item.val;
        }
      });
    },
    // 选择运输方式
    changetransportMethod(e) {
      this.transportModeList.forEach((item) => {
        if (item.confDictId == e) {
          this.baseInForm.transportMethod = item.val;
        }
      });
    },
    // 选择入仓仓库
    changeStorageList(e) {
      this.transportPlanInfoReq.storageName = "";
      if (e) {
        this.storageList.forEach((item) => {
          if (item.documentId == e) {
            this.transportPlanInfoReq.storageName = item.name;
          }
        });
      }
    },
    getObjectUserDownListemployee(e) {},
    // 根据对象类型获取对象的下拉列表 111
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          // if (key == "dept") {
          //   this.depList = arrs;
          // }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 选择回单要求
    changernRequireName(e) {
      this.baseInForm.rnRequireName = "";
      // baseInForm.rnRequireConfDictId
      this.rnrderRequireList.forEach((item) => {
        if (e == item.confDictId) {
          this.baseInForm.rnRequireName = item.key;
        }
      });
    },
    // 选择收货方式
    changereceiveMethod(e) {
      this.baseInForm.receiveMethod = "";
      this.ReceivingMethodList.forEach((item) => {
        if (e == item.confDictId) {
          this.baseInForm.receiveMethod = item.key;
        }
      });
    },

    // 获取组织架构列表
    getDeptList() {
      this.$API
        .wtl_getDeptList({
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.depList = res.data.result.data || [];
        });
    },

    // 获取客户列表
    getCustomerList() {
      this.$API
        .CustomerList({
          customerName: this.queryData4.customerName || "",
          pageStart: 1,
          pageTotal: 200,
          approveStatus: "tong_guo:approve_status",
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      if (this.dialogForm2.objectStatusType) {
        this.$API
          .wtl_getObjectUserDownList({
            key: this.dialogForm2.objectStatusType || "",
            name: name || "",
            pageStart: 1,
            pageTotal: 200,
          })
          .then((res) => {
            this.CustomerListsYF = res.data.result.data || [];
          });
      }
    },
    // 选择垫付人
    changeEM(val) {
      console.log("employeeList", val);
      this.employeeList.forEach((item) => {
        if (item.documentId == val) {
          this.dialogForm2.applyEmployeeName = item.name;
        }
      });
    },
    // 获取员工 employee
    getemployee(name, type) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "employee",
          name: name || "",
          pageStart: 1,
          pageTotal: 50,
        })
        .then((res) => {
          this.employeeList = res.data.result.data || [];
          if (type == "getdefault" && this.employeeList.length > 0) {
            // 获取默认员工
            this.dialogForm2.applyEmployeeId = Number(
              this.employeeList[0].documentId
            );
          }
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm2.objectNumber = item.number;
            // this.dialogForm2.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    // 获取客户档案列表()
    getCustomerListAddress(name) {
      this.$API
        .wtl_getCustomerList({
          customerName: name || "",
          approveStatus: "tong_guo:approve_status", //审核通过
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.addressNaemList = res.data.result.data || [];
        });
    },
    changecustomerId(e) {
      if (!e) {
        this.getCustomerListAddress();
      } else {
        this.getCustomerAddrList();
      }
    },

    // 根据客户id获取客户默认地址
    getCustomerDefaultAddrList(id) {
      this.$API
        .wtl_getCustomerDefaultAddrList({ customerId: id })
        .then((res) => {
          let datas = res.data.result || [];
          if (datas.length > 0) {
            let jjAddressData = {}; // 寄件默认地址;
            let sjAddressData = {}; // 收件默认地址;
            datas.forEach((item) => {
              if (item.addressType == "ji_jian:address_type") {
                jjAddressData = item;
              }
              if (item.addressType == "shou_jian:address_type") {
                sjAddressData = item;
              }
            });

            if (jjAddressData) {
              jjAddressData.contacts = jjAddressData.personnelName;
              jjAddressData.company = jjAddressData.deptName;

              this.goodsInfoList[0].addressReq = JSON.parse(
                JSON.stringify(jjAddressData)
              );
            }
            if (sjAddressData) {
              sjAddressData.contacts = sjAddressData.personnelName || "";
              sjAddressData.company = sjAddressData.deptName || "";
              this.shouJiForm = JSON.parse(JSON.stringify(sjAddressData));
              // this.shouJiForm.contacts = this.shouJiForm.personnelName || "";
              // this.shouJiForm.company = this.shouJiForm.deptName || "";
              this.shouJiForm.serialNumber = 1;
              // console.log("this.shouJiForm.company", this.shouJiForm.company);
            }
          }
        });
    },

    // 打开客户弹窗
    changeCustomerDia() {
      this.getCustomerList();
      this.isShowDialog4 = true;
    },
    // 提货单弹窗
    changeTiHuoDanDia() {
      this.isShowDialog5 = true;
      this.getHeardTable();
      // this.getData();
      this.getQueryList();
    },
    // // 自动生成单号
    // autoCreateNumber() {
    //   this.$API.wtl_createBillNumber().then((res) => {
    //     this.baseInForm.waybillNumber = res.data.result.number || "";
    //   });
    // },

    // 收录客户地址
    autoAddCustomerAddr(datas) {
      let param = {
        address: datas.address || "",
        addressType: datas.addressType || "",
        cityName: datas.cityName || "",
        contacts: datas.contacts || "",
        customerId: datas.customerId || "",
        provinceName: datas.provinceName || "",
        tel: datas.tel || "",
        addressName: datas.addressName || "",
        areaName: datas.areaName || "",
        phone: datas.phone || "",
        remarks: datas.remarks || "",
        deptName: datas.deptName || "",
      };
      this.$API.autoAddCustomerAddr(param).then((res) => {});
    },

    // 提交
    submit(type) {
      // 处理数据
      //
      // if (!this.CaiWuData.settlementMethodConfDictId) {
      //   this.$message.error("结算方式不能为空");
      //   return false;
      // }

      // 运单基本信息
      let baseInfoReq = JSON.parse(JSON.stringify(this.baseInForm));

      // baseInfoReq.isReturnGoods = baseInfoReq.isReturnGoods || 0;
      // baseInfoReq.isWaitNoticeSend = baseInfoReq.isWaitNoticeSend || 0;
      baseInfoReq.rnRequireCount = baseInfoReq.rnRequireCount || 0;
      baseInfoReq.declaredValue =
        (this.baseInForm.isInsure && baseInfoReq.declaredValue) || 0;
      baseInfoReq.declaredValueRate =
        (this.baseInForm.isInsure && baseInfoReq.declaredValueRate) || 0;

      baseInfoReq.takeTime = baseInfoReq.takeTime
        ? baseInfoReq.takeTime + " 00:00:00"
        : "";
      baseInfoReq.deliveryTime = baseInfoReq.deliveryTime
        ? baseInfoReq.deliveryTime
        : "";

      // 运单财务应收信息
      let financeInInfoReq = JSON.parse(JSON.stringify(this.CaiWuData));

      financeInInfoReq.channelArrivalArea = baseInfoReq.channelArrivalArea;
      financeInInfoReq.channelArrivalAreaCode =
        baseInfoReq.channelArrivalAreaCode;
      financeInInfoReq.channelName = baseInfoReq.channelName;
      financeInInfoReq.channelId = baseInfoReq.channelId;
      // 金额这些如果没有要传0
      financeInInfoReq.againSendFee = financeInInfoReq.againSendFee || 0;
      financeInInfoReq.agentAmount = financeInInfoReq.agentAmount || 0;
      financeInInfoReq.allOtherFee = financeInInfoReq.allOtherFee || 0;
      financeInInfoReq.basicFreight = financeInInfoReq.basicFreight || 0;
      financeInInfoReq.billingAmount = financeInInfoReq.billingAmount || 0;
      financeInInfoReq.goodsDeductedAmoun =
        financeInInfoReq.goodsDeductedAmoun || 0;
      financeInInfoReq.insuranceFee = financeInInfoReq.insuranceFee || 0;
      financeInInfoReq.invoiceTaxPoint = financeInInfoReq.invoiceTaxPoint || 0;
      financeInInfoReq.isInvoice = financeInInfoReq.isInvoice || 0;
      financeInInfoReq.monthlyAmount = financeInInfoReq.monthlyAmount || 0;
      financeInInfoReq.packageFee = financeInInfoReq.packageFee || 0;
      financeInInfoReq.receivedAmount = financeInInfoReq.receivedAmount || 0;
      financeInInfoReq.rnorderAmount = financeInInfoReq.rnorderAmount || 0;
      financeInInfoReq.sendFee = financeInInfoReq.sendFee || 0;
      financeInInfoReq.senderAmount = financeInInfoReq.senderAmount || 0;
      financeInInfoReq.takeFee = financeInInfoReq.takeFee || 0;
      financeInInfoReq.taxes = financeInInfoReq.taxes || 0;
      financeInInfoReq.totalFreight = financeInInfoReq.totalFreight || 0;
      financeInInfoReq.unLoadFee = financeInInfoReq.unLoadFee || 0;
      financeInInfoReq.upstairsFee = financeInInfoReq.upstairsFee || 0;
      financeInInfoReq.waitingFee = financeInInfoReq.waitingFee || 0;
      // 运单财务应付信息
      let financeOutInfoReqs = JSON.parse(
        JSON.stringify(this.financeOutInfoReqs)
      );
      financeOutInfoReqs.forEach((item) => {
        delete item.objectStatusType;
        delete item.paymentMethod;
        item.amount = item.amount || 0;
      });
      // 运单收货地址信息
      let receiveAddrReq = JSON.parse(JSON.stringify(this.shouJiForm));
      // 运单提货地址信息
      let takeAddrItemReqs =
        JSON.parse(JSON.stringify(this.goodsInfoList)) || [];
      takeAddrItemReqs.forEach((item, index) => {
        item.addressReq.serialNumber = index + 1;
        delete item.areaNameList;
        delete item.cityNameList;
        item.itemReqs.forEach((item2, index2) => {
          item2.billingWeight = item2.billingWeight || 0; //没有的默认提交0
          item2.packageCout = item2.packageCout || 0; //没有的默认提交0
          item2.grossWeight = item2.grossWeight || 0; //没有的默认提交0
          item2.netWeight = item2.netWeight || 0; //没有的默认提交0
          item2.volumeWeight = item2.volumeWeight || 0; //没有的默认提交0
          item2.volumeDivisor = item2.volumeDivisor || 0; //没有的默认提交0
          item2.volume = item2.volume || 0; //没有的默认提交0
          item2.unitPrice = item2.unitPrice || 0; //没有的默认提交0
          item2.freight = item2.freight || 0; //没有的默认提交0

          item2.serialNumber = index2 + 1;
          delete item2.CategoryList;
          delete item2.packageNameList;
        });
      });

      let fids = [];

      this.fileNameLists.forEach((item) => {
        let obj = {
          fileId: item.name,
          operationType: item.operationType || "ADD",
        };
        fids.push(obj);
      });

      // 找出删除的图片
      let fName = this.fileNameLists.map((itemA) => {
        return itemA.name;
      });
      let delArrs = [];
      this.fileVoListAll.forEach((item1) => {
        if (fName.indexOf(item1.name) === -1) {
          let objs1 = {
            fileId: item1.name,
            operationType: "DEL",
          };
          delArrs.push(objs1);
        }
      });
      fids = [...fids, ...delArrs];

      baseInfoReq.isInsure = baseInfoReq.isInsure ? 1 : 0;
      baseInfoReq.isRelatePickCommand = baseInfoReq.isRelatePickCommand ? 1 : 0;
      baseInfoReq.isSorting = baseInfoReq.isSorting ? 1 : 0;

      financeOutInfoReqs = [...financeOutInfoReqs, ...this.delArrsFInList];

      let param = {
        // fileIds: fids,
        // baseInfoReq: baseInfoReq,
        financeInInfoReq: financeInInfoReq,
        financeOutInfoReqs: financeOutInfoReqs,
        // receiveAddrReq: receiveAddrReq,
        takeAddrItemReqs: takeAddrItemReqs,
        // transportPlanReq: {},
        isPosting: type || 0, // 1=过账 0=保存
        waybillSplitId: this.waybillSplitId,
      };
      this.$API.updateWaybillFinance(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.$TOOLS.closePage();
        this.$router.push({
          path: "/WaybillManage/ComprehensiveQuery",
          query: {
            isreload: "isreload",
          },
        });
      });
    },
    // 删除一行货物信息
    delGoods(idx1, idx2, idx3) {
      let datas = JSON.parse(JSON.stringify(this.goodsInfoList)) || [];
      datas[idx1].itemReqs[idx2].itemSpecsReqs.splice(idx3, 1);
      this.goodsInfoList = datas;
    },
    // 添加一应收费项
    AddFeiXian() {
      this.isShowDialog = true;
      this.dialogTitle = "新建应收费项";
      this.dialogType = "add";
    },
    editFeiXian(row, deitIdx) {
      this.isShowDialog = true;
      this.dialogTitle = "编辑应收费项";
      this.dialogType = "edit";
      this.deitIdx = deitIdx;
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },
    // 添加应付弹窗
    async addYinFu() {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "新建应付";
      this.dialogType2 = "add";
      this.fileNameLists6 = [];

      let userInfo = window.localStorage.getItem("userInfo") || "";

      if (userInfo) {
        let udatas = JSON.parse(userInfo);
        this.getemployee(udatas.employeeName, "getdefault");
        this.dialogForm2.applyEmployeeName = udatas.employeeName;
      }
      this.itemCategorChooseA("", 0); //费型类型下拉列表
      this.settlementMethodList.forEach((element) => {
        if (element.key == "ji_fu_xian_jie") {
          this.dialogForm2.paymentMethodConfDictId = element.confDictId;
          this.dialogForm2.paymentMethod = element.val;
        }
      });
    },
    // 删除一行货物信息
    delFeiXian(idx2) {
      this.CaiWuData.itemServiceReqs.splice(idx2, 1);
      this.getOtherExpenses();
    },
    // 删除一行货物信息
    delFeiXian2(idx2) {
      let arrs = JSON.parse(JSON.stringify(this.financeOutInfoReqs)) || [];
      if (arrs[idx2].operationType !== "ADD") {
        arrs[idx2].operationType = "DEL";
        this.delArrsFInList.push(arrs[idx2]);
      }
      arrs.splice(idx2, 1);
      this.financeOutInfoReqs = arrs;

      this.updateWaybillFinanceOut();
    },
    async EditFeiXian(row, idx) {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "编辑应付";
      this.dialogType2 = "edit";
      this.editYfIdx = idx;
      this.fileNameLists6 = [];

      let datas = JSON.parse(JSON.stringify(row)); //如果不转表格跟弹窗的数据会一起变
      datas.itemCategoryList = [];
      datas.itemCategoryList.push({
        amount: row.amount,
        itemCategoryId: row.itemCategoryId,
        itemCategoryName: row.itemCategoryName,
        categoryNameList: [],
        CategoryServiceList: [],
        itemServiceName: row.itemServiceName,
        itemServiceId: row.itemServiceId,
      });
      console.log(row);
      if (row.fileVos && row.fileVos.length) {
        let arrs = row.fileVos.map((item) => {
          return {
            name: item.fileId,
            url: item.fileUrl,
          };
        });
        this.fileNameLists6 = arrs;
      }
      this.getemployee(row.applyEmployeeName);
      this.wtl_itemServiceListAll(row.itemCategoryId, "fu:direction_status", 0);
      this.dialogForm2 = datas;
      this.itemCategorChooseA("", 0); //费型类型下拉列表
      this.objectStatusList.forEach((item) => {
        if (item.confDictId == this.dialogForm2.objectStatusConfDictId) {
          this.dialogForm2.objectStatusType = item.key;
        }
      });
      this.getObjectUserDownListYf(); //获取结算对象
      // this.wtl_itemServiceListAll(
      //   this.dialogForm2.itemCategoryId,
      //   "fu:direction_status"
      // ); //获取费项(应收)
    },

    // 选择品名
    changeGoodsName(val, idx) {},

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      // 添加费项
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.dialogForm));
          let items = {
            amount: datas.amount,
            itemCategoryId: datas.itemCategoryId,
            itemCategoryName: datas.itemCategoryName,
            itemServiceId: datas.itemServiceId,
            itemServiceName: datas.itemServiceName,
            remarks: datas.remarks,
          };
          if (this.dialogType == "add") {
            // 判断是否存在
            let flag = false;
            this.CaiWuData.itemServiceReqs.forEach((item) => {
              if (item.itemServiceId == items.itemServiceId) {
                flag = true;
              }
            });

            if (flag) {
              this.$message.warning("该费项已存在");
              return false;
            } else {
              this.CaiWuData.itemServiceReqs.push(items);

              this.$message.success("添加成功");
            }
          } else {
            //编辑
            let arrs = JSON.parse(
              JSON.stringify(this.CaiWuData.itemServiceReqs)
            );
            this.CaiWuData.itemServiceReqs.forEach((item, index) => {});

            arrs[this.deitIdx] = items;
            this.CaiWuData.itemServiceReqs = arrs;
          }

          // 动态计算其他费用
          let arrs = [];
          this.CaiWuData.itemServiceReqs.forEach((item) => {
            arrs.push(item.amount);
          });
          this.getOtherExpenses(arrs);
          this.isShowDialog = false;
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    handleCloseDia7() {
      this.isShowDialog7 = false;
      this.dialogForm7 = {
        allOtherFee: "",
        basicFreight: "",
        sendFee: "",
        totalAmount: "",
        outgoingId: "",
        outgoingRemarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn7() {
      this.$API.waybillupdateOutgoingFee(this.dialogForm7).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog7 = false;
        this.getWaybillOutgoingFinance();
      });
    },
    edit7(row) {
      this.isShowDialog7 = true;
      this.dialogForm7 = {
        allOtherFee: row.allOtherFee,
        basicFreight: row.basicFreight,
        sendFee: row.sendFee,
        totalAmount: row.totalAmount,
        outgoingId: row.outgoingId,
        outgoingRemarks: row.outgoingRemarks,
      };
    },
    // 选择图片
    changeFileList8(array) {
      this.fileNameLists8 = array;
    },
    handleCloseDia8() {
      this.isShowDialog8 = false;
      this.dialogForm8 = {
        financeId: "",
        amount: "",
        inoutStatus: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        objectStatusType: "",
        paymentMethodConfDictId: "",
        remarks: "",
        fileIds: [],
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn8() {
      this.dialogForm8.fileIds = this.fileNameLists8.map((item) => {
        return item.name;
      });
      this.$API
        .waybillupdateSignforWaybillFile(this.dialogForm8)
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialog8 = false;
          this.getWaybillDispatchFinance();
        });
    },
    edit8(row) {
      this.isShowDialog8 = true;
      this.dialogForm8 = {
        financeId: row.financeId,
        amount: row.amount,
        inoutStatus: row.inoutStatus,
        itemCategoryId: row.itemCategoryId,
        itemCategoryName: row.itemCategoryName,
        itemServiceId: row.itemServiceId,
        itemServiceName: row.itemServiceName,
        objectName: row.objectName,
        objectNumber: row.objectNumber,
        objectStatusConfDictId: row.objectStatusConfDictId,
        objectStatusType: "",
        paymentMethodConfDictId: row.paymentMethodConfDictId,
        remarks: row.remarks,
        // fileIds: row.remarks,
      };
      let fileVoList = [];
      let fileList = row.fileList || [];
      fileList.forEach((item) => {
        if (item.fileId && item.fileUrl) {
          fileVoList.push({
            name: item.fileId,
            url: item.fileUrl,
          });
        }
      });
      this.fileNameLists8 = fileVoList;
      if (this.dialogForm8.objectStatusConfDictId) {
        this.objectStatusList.forEach((item) => {
          if (item.confDictId == this.dialogForm8.objectStatusConfDictId) {
            this.dialogForm8.objectStatusType = item.key;
          }
        });
        this.getObjectUserDownListYf8();
      }
      if (this.dialogForm8.itemCategoryId) {
        this.changeItemCategoryIdYF8(this.dialogForm8.itemCategoryId);
      }
    },

    /***
     * 应付
     */
    handleCloseDia2() {
      this.isShowDialog2 = false;

      this.fileNameLists6 = [];
      this.dialogForm2 = {
        // 弹窗表单数据
        amount: "",
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatus: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethod: "", //付款方式名称(我自己加的)
        operationType: "ADD",
        applyEmployeeId: "",
        itemCategoryList: [
          {
            amount: 0,
            itemCategoryId: "",
            itemCategoryName: "",
            categoryNameList: [],
            CategoryServiceList: [],
            itemServiceName: "",
            itemServiceId: "",
          },
        ],
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 添加费项
          // let items = {
          //   amount: "",
          //   inoutStatus: "zhi_chu:deal_status", //收支类型 shou_ru:deal_status=收入 zhi_chu:deal_status=支出
          //   itemCategoryId: "",
          //   itemCategoryName: "",
          //   itemServiceId: "",
          //   itemServiceName: "",
          //   objectName: "",
          //   objectNumber: "",
          //   objectStatusConfDictId: "",
          //   paymentMethodConfDictId: "",
          //   remarks: "",
          // };
          console.log("dialogForm2", this.dialogForm2);
          console.log("dialogType2", this.dialogType2);
          let objs = JSON.parse(JSON.stringify(this.dialogForm2));
          if (objs.itemCategoryList.length < 1) {
            this.$message.error("费项不能为空");
            return false;
          }
          if (!objs.objectName) {
            this.$message.error("结算对象不能为空");
            return false;
          }
          let arrs = JSON.parse(JSON.stringify(this.financeOutInfoReqs));

          if (this.dialogType2 == "add") {
            objs.itemCategoryList.forEach((item) => {
              let elementS = JSON.parse(JSON.stringify(objs));
              elementS.operationType = "ADD";
              elementS.itemCategoryId = item.itemCategoryId;
              elementS.itemCategoryName = item.itemCategoryName;
              elementS.amount = item.amount;
              elementS.itemServiceName = item.itemServiceName;
              elementS.itemServiceId = item.itemServiceId;
              delete elementS.categoryNameList;
              delete elementS.CategoryServiceList;
              delete elementS.itemCategoryList;
              arrs.push(elementS);
              this.financeOutInfoReqs = arrs;
            });
            // this.isShowDialog2 = false;
          } else {
            // editYfIdx

            let formDatas = JSON.parse(JSON.stringify(objs));
            console.log("编辑", objs);
            console.log("arrs", arrs);

            formDatas.itemCategoryId =
              formDatas.itemCategoryList[0].itemCategoryId;
            formDatas.itemCategoryName =
              formDatas.itemCategoryList[0].itemCategoryName;
            formDatas.amount = formDatas.itemCategoryList[0].amount;
            formDatas.itemServiceName =
              formDatas.itemCategoryList[0].itemServiceName;
            formDatas.itemServiceId =
              formDatas.itemCategoryList[0].itemServiceId;
            delete formDatas.itemCategoryList;

            arrs[this.editYfIdx] = formDatas;
            this.financeOutInfoReqs = arrs;
            // this.isShowDialog2 = false;
          }
          this.updateWaybillFinanceOut();
        }
      });
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * 应付
     */
    handleCloseDia4() {
      this.isShowDialog4 = false;
      this.queryData4.customerName = "";
    },
    //  弹窗确认保存事件
    diaConfirmBtn4(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isShowDialog4 = false;
        }
      });
    },
    handleCloseDia5() {
      this.isShowDialog5 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn5() {
      // let array = this.selectTableData5 || [];
      // if (array.length == 0) {
      //   this.$message.error("请选择提货单");
      // }
    },
    changecommandId(row) {
      this.baseInForm.commandNumber = row.commandNumber || "";
      this.baseInForm.commandId = row.commandId || "";

      // this.baseInForm.waybillNumber = row.waybillNumber || "";
      // this.baseInForm.customerOrderNumber = row.customerOrderNumber || "";
      // this.baseInForm.takeTime = row.takeTime || "";
      // this.baseInForm.takeStatus = row.takeStatus || "";
      // this.baseInForm.remarks = row.remarks || "";

      // this.baseInForm.customerName = row.customerName;
      // this.baseInForm.customerNumber = row.customerNumber;
      // // this.baseInForm.customerId = item.customerId ||'';
      // // this.baseInForm.businessDeptId = row.deptId || "";
      // // 发货地址
      // this.goodsInfoList[0].addressReq.contacts = row.startContacts || "";
      // this.goodsInfoList[0].addressReq.company = row.startCompany || "";
      // this.goodsInfoList[0].addressReq.phone = row.startPhone || "";
      // this.goodsInfoList[0].addressReq.provinceName = "";
      // this.goodsInfoList[0].addressReq.cityName = "";
      // this.goodsInfoList[0].addressReq.areaName = "";
      // this.goodsInfoList[0].addressReq.address = row.startAddr || "";
      // this.geocodeFH(row.startAddr, 0);
      // // 货物信息
      // let goodsArrs = JSON.parse(JSON.stringify(this.goodsInfoList)) || [];
      // goodsArrs[0].itemReqs[0].goodsName = row.goodsName || "";
      // goodsArrs[0].itemReqs[0].grossWeight = row.grossWeight || "";
      // goodsArrs[0].itemReqs[0].netWeight = row.netWeight || "";
      // goodsArrs[0].itemReqs[0].packageCout = row.packageCount || "";
      // goodsArrs[0].itemReqs[0].volume = row.volume || "";

      // this.goodsInfoList = goodsArrs;
      // // 收货地址
      // this.shouJiForm.contacts = row.endContacts || "";
      // this.shouJiForm.company = row.endCompany || "";
      // this.shouJiForm.phone = row.endPhone || "";
      // this.shouJiForm.address = row.endAddr || "";
      // this.shouJiForm.provinceName = "";
      // this.shouJiForm.cityName = "";
      // this.shouJiForm.areaName = "";
      // this.geocode(row.endAddr);
      // this.isShowDialog5 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    /***
     * 收件地址
     */
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData = {
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn3() {
      // 添加费项
      this.isShowDialog3 = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn3() {
      this.isShowDialog3 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .formbox {
    padding: 0 30px;

    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin-top: 30px;
    border-bottom: 4px solid #ccc;
    padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  width: 100%;
  /deep/ .el-table .cell {
    padding-right: 0;
    padding-left: 0;
  }

  .speckTable {
    margin: 20px auto;
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.checkBox {
  margin-left: 30px;
}

.tiHuoGuiHua {
  // padding: 0 30px;

  .checkBoxs {
    font-size: 14px;
    margin: 0 0 10px 30px;
  }
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 30px 10px;
}

.displayFlex {
  display: flex;
  align-items: center;
}

.addressBox {
  background-color: #f2f2f2;
  padding: 10px;
  border: 2px dashed #ddd;
  margin: 10px 0;
  border-radius: 4px;
}

.feeAtherTb {
  width: 80%;
  margin: 10px 30px;
  box-sizing: border-box;
}

.huoWuBox {
  margin: 0 auto;
  display: flex;
  width: 66%;

  .saveBtnsAddGG {
    height: 40px;
    margin: 20px 0 0 20px;
  }
}

.glo_formBox {
  /deep/ .el-form-item {
    height: 30px;
    line-height: 30px;
  }
}

.queryBtnsList {
  display: flex;

  .queryBts {
    width: 80px;
    height: 30px;
    line-height: 30px;
    padding: 0;
    background-color: #ef7c0a;
    color: #fff;
  }
}
.addBTnsa {
  display: flex;
  justify-content: flex-end;
}
.linkTabel {
  text-align: center;
  cursor: pointer;
}

.feeLists {
  display: flex;
  align-items: center;
  width: 100%;

  .icons {
    font-size: 26px;
    margin: 0 0 23px 10px;
  }

  .glo_disflex {
    width: 100px;
  }
}
</style>
